<template>
  <div>
    <div :class="{ 'page-wrapper': !isTeamExecutivePopup }">
      <div :class="{ 'page-content-wrapper': !isTeamExecutivePopup }">
        <div class="shadow-btm" v-if="!isTeamExecutivePopup">
          <div class="row">
            <div class="col-lg-12 col-sm-12 my-auto d-flex align-items-center mb-4">
              <h4 class="mb-0 lg-bld">{{ id ? "Edit" : "Add" }} Executive</h4>
            </div>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="row">
              <div class="col-lg-12 col-sm-10 float-none">
                <div class="card border mb-0 radius-15">
                  <div class="card-body">
                    <ul class="tabs px-0">
                      <li :class="{ active: activeTab === 1 }" @click="changeTab(1)">Executive Details</li>
                      <li :class="{ active: activeTab === 2, disabled: !detail.id }" @click="changeTab(2)">Career History</li>
                      <li :class="{ active: activeTab === 3, disabled: !detail.id }" @click="changeTab(3)">
                        Biography / Roles & Responsibilities
                      </li>
                      <li :class="{ active: activeTab === 4, disabled: !detail.id }" @click="changeTab(4)">
                        Contact and Web References
                      </li>
                      <li :class="{ active: activeTab === 5, disabled: !detail.id }" @click="changeTab(5)">Image</li>
                      <li :class="{ active: activeTab === 6, disabled: !detail.id }" @click="changeTab(6)">
                        Interesting Facts
                      </li>
                    </ul>
                    <!-- 🔹 Bio Source URL + Prefill Button (INLINE STYLES ONLY) -->
                    <div class="row align-items-end mb-3" v-if="activeTab === 1 && !isTeamExecutivePopup && !id">
                      <!-- Bio Source URL -->
                      <div class="col-lg-6 col-sm-6">
                        <div class="form-group mb-0">
                          <Field
                            type="text"
                            class="form-control"
                            name="executive_url"
                            placeholder="Paste executive profile URL to auto-fetch details"
                            v-model="singleexecutiveurl" />
                        </div>
                      </div>

                      <!-- Button with GAP -->
                      <div class="col-lg-2 col-sm-3 ml-2 d-flex align-items-center">

                        <!-- 🔥 OLD FETCH BUTTON (AS IT IS) -->
                        <button
                          type="button"
                          @click="fetchSingleExecutiveFromAi()"
                          :disabled="fetchSingleExecutiveFromAiLoading"
                          style="
                            height: 38px;
                            padding: 0 16px;
                            font-size: 13px;
                            font-weight: 400;

                            background: linear-gradient(to right, #4caf50 0%, #45a049 50%, #4caf50 100%);
                            color: #fff;

                            border: 1px solid #4caf50;
                            border-radius: 4px;

                            outline: none;
                            box-shadow: none;
                            cursor: pointer;

                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            gap: 6px;
                          "
                        >
                          <!-- Loader -->
                          <span
                            v-if="fetchSingleExecutiveFromAiLoading"
                            style="
                              width: 14px;
                              height: 14px;
                              border: 2px solid rgba(255,255,255,0.4);
                              border-top-color: #fff;
                              border-radius: 50%;
                              animation: spin 0.8s linear infinite;
                            "
                          ></span>

                          <span>
                            {{ fetchSingleExecutiveFromAiLoading ? 'Fetching…' : 'Fetch' }}
                          </span>
                        </button>

                        <!-- 🔥 I BUTTON (JUST NEXT TO FETCH) v-if="singleExecShowOnUi" -->
                        <div
                          v-if="singleExecShowOnUi"
                          class="ai-info-wrapper ml-2"
                          @click.stop
                        >
                          <span class="ai-info-btn" @click="showSingleExecInfo = !showSingleExecInfo">ℹ️</span>

                          <div v-if="showSingleExecInfo" class="ai-info-popup">
                            <div class="ai-popup-header">
                              <img
                                :src="singleExecShowOnUi[0].ImageUrl || '/img/user-pic.png'"
                                class="ai-popup-avatar"
                              />
                            </div>

                            <div
                              v-for="(value, key) in singleExecShowOnUi[0]"
                              :key="key"
                              class="ai-info-row"
                            >
                              <strong>{{ key }}</strong> {{ value }}
                            </div>
                          </div>
                        </div>

                      </div>                      
                    </div>  
                    <div
                      v-if=" !isTeamExecutivePopup &&
                        (
                        detail.job_title_suggestion_message ||
                        detail.job_function_suggestion_message ||
                        detail.industry_suggestion_message ||
                        detail.seniority_suggestion_message ||
                        detail.country_suggestion_message ||
                        detail.company_suggestion_message
                    )
                      "
                      class="alert alert-warning py-2 mb-2"
                      style="margin-top: 10px; font-size: 12px; line-height: 1.4; padding: 8px 12px; background-color: #fff3cd; border: 1px solid #ffeeba;"
                    >
                      <div v-if="detail.is_duplicate_executive">
                        <span class="ml-1">A duplicate executive name was found.</span>
                      </div>
                      <div v-if="detail.job_title_suggestion_message">
                        <span class="ml-1">Possible job title matches:</span>
                        <strong>{{ detail.job_title_suggestion_message }}</strong>
                      </div>

                      <div v-if="detail.job_function_suggestion_message">
                        <span class="ml-1">Possible job function matches:</span>
                        <strong>{{ detail.job_function_suggestion_message }}</strong>
                      </div>
                      
                      <div v-if="detail.industry_suggestion_message">
                        <span class="ml-1">Possible industry matches:</span>
                        <strong>{{ detail.industry_suggestion_message }}</strong>
                      </div>      
                      
                      <div v-if="detail.seniority_suggestion_message">
                        <span class="ml-1">Possible seniority matches:</span>
                        <strong>{{ detail.seniority_suggestion_message }}</strong>
                      </div>

                      <div v-if="detail.country_suggestion_message">
                        <span class="ml-1">Possible country matches:</span>
                        <strong>{{ detail.country_suggestion_message }}</strong>
                      </div>

                      <div v-if="detail.company_suggestion_message">
                        <span class="ml-1">Possible company matches:</span>
                        <strong>{{ detail.company_suggestion_message }}</strong>
                      </div>
                    </div>                                      
                    <Form @submit="saveExecutiveDetails" ref="executiveDetailForm">
                      <!-- Tab 1 start here -->
                      <div class="col-12" v-if="activeTab === 1">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="form-group my-2 w-20 mr-3">
                            <!-- Executive Name dropdown -->
                            <label>Executive Name</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="Executive_Name"
                              placeholder="Executive Name"
                              rules="required: executive name"
                              v-model="detail.executive_name"
                              :validateOnInput="true"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="executive_name"
                                label="executive_name"
                                valueProp="executive_name"
                                placeholder="Select"
                                v-model="detail.executive_name"
                                :options="executiveOptions"
                                :create-option="true"
                                searchable="true"
                                v-bind="field"
                                @search-change="searchexecutiveName2($event)">
                                <template v-slot:option="{ option }">
                                  <div class="col-12 row" style="padding: 0">
                                    <div class="col-11">
                                      <img
                                        class="option-icon"
                                        :src="option.executive_logo ? option.executive_logo : '/img/user-pic.png'" />
                                      {{ option.executive_name }}
                                    </div>
                                    <div class="col-1">
                                      <img
                                        class="option-icon2"
                                        :src="
                                          option.new_company && option.new_company.company_logo
                                            ? option.new_company.company_logo
                                            : '/img/user-pic.png'
                                        "
                                        :title="
                                          option.new_company && option.new_company.company_name
                                            ? option.new_company.company_name
                                            : ''
                                        " />
                                    </div>
                                  </div>
                                </template>
                              </Multiselect>
                              <ErrorMessage name="Executive_Name" class="text-danger" />
                            </Field>
                          </div>
                          <!-- Gender Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Gender</label>
                            <span class="text-danger">*</span>
                            <Field
                              as="select"
                              class="form-control"
                              name="Gender"
                              rules="required: gender"
                              :validateOnInput="true"
                              v-model="detail.gender">
                              <option value="">Select</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                            </Field>
                            <ErrorMessage name="Gender" class="text-danger" />
                          </div>
                          <!-- Current role since(Month) -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Current role since (Month)</label>
                            <div class="row">
                              <div class="col-lg-6 col-6">
                                <Field as="select" class="form-control" name="month" v-model="detail.curr_month">
                                  <option value="">Select Month</option>
                                  <option value="January">January</option>
                                  <option value="February">February</option>
                                  <option value="March">March</option>
                                  <option value="April">April</option>
                                  <option value="May">May</option>
                                  <option value="June">June</option>
                                  <option value="July">July</option>
                                  <option value="August">August</option>
                                  <option value="September">September</option>
                                  <option value="October">October</option>
                                  <option value="November">November</option>
                                  <option value="December">December</option>
                                </Field>
                              </div>
                              <div class="col-lg-6 col-6">
                                <Field
                                  type="text"
                                  name="year"
                                  class="form-control"
                                  placeholder="year"
                                  v-model="detail.curr_year"
                                  v-slot="{ field }">
                                  <Datepicker
                                    autoApply
                                    placeholder="year"
                                    v-bind="field"
                                    v-model="detail.curr_year"
                                    yearPicker />
                                </Field>
                              </div>
                            </div>
                          </div>
                          <!-- C-Suite Checkbox (saved as operating_committee) -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>C-Suite</label>
                            <div>
                              <input
                                type="checkbox"
                                id="OperatingCommittee"
                                name="OperatingCommittee"
                                style="height: 30px; width: 24px"
                                true-value="1"
                                false-value="0"
                                v-model="detail.operating_committee" />
                            </div>
                          </div>
                          <!-- Board Membership Checkbox -->
                          <div class="form-group my-2 w-20">
                            <label>Board Membership</label>
                            <div>
                              <input
                                type="checkbox"
                                id="is_board_membership"
                                name="is_board_membership"
                                style="height: 30px; width: 24px"
                                true-value="1"
                                false-value="0"
                                v-model="detail.is_board_member" />
                            </div>
                          </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                          <!-- Job Title Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Job Title</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="new_job_title_id"
                              placeholder="Select"
                              rules="required:job title"
                              :validateOnInput="true"
                              v-model="detail.new_job_title_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="title"
                                label="title"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.new_job_title_id"
                                :create-option="true"
                                :options="jobTitleList"
                                v-on:change="getSeniorityDetail($event, 'NEW')"
                                searchable="true"
                                v-bind="field" 
                              >
                              <!-- Add new job title option at bottom -->
                              <template #afterlist>
                                <div
                                  class="multiselect-add-option"
                                  v-if="$helperService.canExportAndPdf(role)"
                                  @click.stop="openAddJobtitlePopup"
                                >
                                  + Add new jobtitle
                                </div>
                              </template>
                            </Multiselect>
                            </Field>
                            <ErrorMessage name="new_job_title_id" class="text-danger" />
                          </div>
                          <!-- Job Function Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Job Function</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="job_function_new"
                              v-model="detail.job_function_id_new"
                              rules="required:  job function"
                              :validateOnInput="true"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="job_function_name"
                                label="job_function_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.job_function_id_new"
                                :options="jobFunctionList"
                                searchable="true"
                                v-bind="field" 
                                >
                                <!-- Add new job title option at bottom -->
                                <template #afterlist>
                                  <div
                                    class="multiselect-add-option"
                                    v-if="$helperService.canExportAndPdf(role)"
                                    @click.stop="openAddJobfunctionPopup"
                                  >
                                    + Add new jobfunction
                                  </div>
                                </template>
                              </Multiselect>
                            </Field>
                            <ErrorMessage name="job_function_new" class="text-danger" />
                          </div>
                          <!-- Seniority Level Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Seniority Level</label>
                            <span class="text-danger">*</span>

                            <Field
                              type="text"
                              name="Seniority"
                              placeholder="Select"
                              rules="required:seniority"
                              :validateOnInput="true"
                              v-model="detail.seniority_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="seniority_name"
                                label="seniority_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.seniority_id"
                                :options="senioritylevelList"
                                searchable="true"
                                v-bind="field" 
                                >
                                <!-- Add new job title option at bottom -->
                                <template #afterlist>
                                  <div
                                    class="multiselect-add-option"
                                    v-if="$helperService.canExportAndPdf(role)"
                                    @click.stop="openAddSeniorityPopup"
                                  >
                                    + Add new Seniority
                                  </div>
                                </template>
                              </Multiselect>
                            </Field>
                            <ErrorMessage name="Seniority" class="text-danger" />
                          </div>
                          <!-- Business Segment -->
                          <div class="form-group my-2 w-20 mr-3" v-if="isShowSegment">
                            <label>Business Segment</label>
                            <span class="text-danger">*</span>

                            <Field
                              type="text"
                              name="Segment"
                              placeholder="Select"
                              v-model="detail.segment_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="name"
                                label="name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.segment_id"
                                :options="segmentList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                            <ErrorMessage name="Segment" class="text-danger" />
                          </div>
                          <!-- Business Unit Checkbox -->
                          <div class="form-group my-2 w-20 mr-3">
                            <div class="col-12 mt-3">
                              <span>Business Unit</span>
                              <div>
                                <input
                                  type="checkbox"
                                  id="BusinessUnit"
                                  name="BusinessUnit"
                                  style="height: 30px; width: 24px"
                                  true-value="1"
                                  false-value="0"
                                  v-model="detail.business_unit" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                          <!-- Company Name dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Company Name</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="new_company_id"
                              placeholder="Select"
                              rules="required: new company"
                              v-model="detail.new_company_id"
                              :validateOnInput="true"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="company_name"
                                label="company_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.new_company_id"
                                :options="companyList"
                                searchable="true"
                                v-bind="field"
                                v-on:change="currentCompanyChange($event, 'NEW')"
                                @search-change="searchCompanyName($event, 'FALSE')">
                                <template v-slot:option="{ option }">
                                  <img
                                    class="option-icon"
                                    :src="option.company_logo ? option.company_logo : '/img/user-pic.png'" />
                                  {{ option.company_name }}
                                </template>
                              </Multiselect>
                            </Field>
                            <ErrorMessage name="new_company_id" class="text-danger" />
                          </div>
                          <!-- Industry Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Industry</label>
                            <Field
                              type="text"
                              name="industry_id_new"
                              placeholder="Select"
                              v-model="detail.industry_id_new"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="industry_name"
                                label="industry_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.industry_id_new"
                                :options="industryList"
                                @change="changeIndustry($event, true)"
                                searchable="true"
                                v-bind="field" 
                              >
                              <!-- Add new job title option at bottom -->
                              <template #afterlist>
                                <div
                                  class="multiselect-add-option"
                                  v-if="$helperService.canExportAndPdf(role)"
                                  @click.stop="openAddIndustryPopup"
                                >
                                  + Add new Industry
                                </div>
                              </template>
                            </Multiselect>
                            </Field>
                          </div>
                          <!-- Subsector Dropdown -->
                          <div v-if="showSubsectorDropdown" class="form-group my-2 w-20 mr-3">
                            <label>{{ subsectorLabel }}</label>
                            <Field
                              type="text"
                              name="subsector_id"
                              placeholder="Select"
                              v-model="detail.subsector_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="industry_name"
                                label="industry_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.subsector_id"
                                :options="subsectorsList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- Current Country Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Current Country</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="Country"
                              rules="required:current country"
                              :validateOnInput="true"
                              v-model="detail.country_id"
                              v-on:change="getsameCountry(detail.country_id, 'NEW')"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="country_name"
                                label="country_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.country_id"
                                :options="countryList"
                                searchable="true"
                                v-bind="field" 
                              >
                              <!-- Add new job title option at bottom -->
                              <template #afterlist>
                                <div
                                  class="multiselect-add-option"
                                  v-if="$helperService.canExportAndPdf(role)"
                                  @click.stop="openAddCountryPopup"
                                >
                                  + Add new Country
                                </div>
                              </template>
                            </Multiselect>
                            </Field>
                            <ErrorMessage name="Country" class="text-danger" />
                          </div>
                          <!-- Current City Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Current City</label>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="CITY"
                              v-model="detail.city_id"
                              v-on:change="getsameCity(detail.city_id)"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="city_name"
                                label="city_name"
                                valueProp="id"
                                v-model="detail.city_id"
                                :options="cityList"
                                :loading="currentcityDropdownLoader"
                                searchable="true"
                                placeholder="Select"
                                @search-change="searchCityName($event)"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- Current Region Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Current Region</label>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="NEW_REGION"
                              v-model="detail.region_id_new"
                              v-on:change="getsameRegion(detail.region_id_new)"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="region_name"
                                label="region_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.region_id_new"
                                :options="regionList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                          <!-- Past Company dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Past Company</label>
                            <Field
                              type="text"
                              name="prev_company_id"
                              placeholder="Select"
                              v-model="detail.prev_company_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="company_name"
                                label="company_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.prev_company_id"
                                :options="companyList"
                                searchable="true"
                                v-bind="field"
                                v-on:change="currentCompanyChange($event, 'OLD')"
                                @search-change="searchCompanyName($event, 'FALSE')">
                                <template v-slot:option="{ option }">
                                  <img
                                    class="option-icon"
                                    :src="option.company_logo ? option.company_logo : '/img/user-pic.png'" />
                                  {{ option.company_name }}
                                </template>
                              </Multiselect>
                            </Field>
                          </div>
                          <!-- Past Industry dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Past Industry</label>
                            <Field
                              type="text"
                              name="industry_id_prev"
                              placeholder="Select"
                              v-model="detail.industry_id_prev"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="industry_name"
                                label="industry_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.industry_id_prev"
                                :options="industryList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- Past Country Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Past Country</label>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="country_id_prev"
                              v-model="detail.country_id_prev"
                              v-on:change="getsameCountry(detail.country_id_prev, 'PAST')"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="country_name"
                                label="country_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.country_id_prev"
                                :options="countryList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- Past City Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Past City</label>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="city_id_prev"
                              v-model="detail.city_id_prev"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="city_name"
                                label="city_name"
                                valueProp="id"
                                v-model="detail.city_id_prev"
                                :options="cityPastList"
                                :loading="pastcityDropdownLoader"
                                searchable="true"
                                placeholder="Select"
                                @search-change="searchCityName($event)"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- Past Region Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Past Region</label>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="region_id_prev"
                              v-model="detail.region_id_prev"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="region_name"
                                label="region_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.region_id_prev"
                                :options="regionList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                          <div class="form-group my-2 w-20 mr-3">
                            <!-- Past Job Title dropdown -->
                            <label>Past Job Title</label>
                            <Field
                              type="text"
                              name="prev_job_title_id"
                              placeholder="Select"
                              v-model="detail.prev_job_title_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="title"
                                label="title"
                                valueProp="id"
                                placeholder="Select"
                                :create-option="true"
                                v-model="detail.prev_job_title_id"
                                v-on:change="getSeniorityDetail($event, 'PREV')"
                                :options="jobTitleList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- Past Job Function dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Past Job Function</label>
                            <Field
                              type="text"
                              placeholder="Select"
                              name="job_function_id_prev"
                              v-model="detail.job_function_id_prev"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="job_function_name"
                                label="job_function_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.job_function_id_prev"
                                :options="jobFunctionList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- Seniority Level Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Past Seniority Level</label>
                            <!-- <span class="text-danger">*</span>  rules="required:seniority" -->

                            <Field
                              type="text"
                              name="Seniority_previous"
                              placeholder="Select"
                              :validateOnInput="true"
                              v-model="detail.seniority_id_prev"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="seniority_name"
                                label="seniority_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.seniority_id_prev"
                                :options="senioritylevelList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                            <!-- <ErrorMessage name="Seniority_previous" class="text-danger" /> -->
                          </div>
                          <!-- Same as current Checkbox -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Same as current</label>
                            <div>
                              <input
                                type="checkbox"
                                id="is_same_as_current"
                                name="is_same_as_current"
                                style="height: 30px; width: 24px"
                                true-value="1"
                                false-value="0"
                                v-on:change="getSameAsCurrent(detail.is_same_as_current)"
                                v-model="detail.is_same_as_current" />
                            </div>
                          </div>
                          <!-- Investor Checkbox -->
                          <div class="form-group my-2 w-20">
                            <span>Investor</span>
                            <div>
                              <input
                                type="checkbox"
                                id="Invester"
                                name="Invester"
                                style="height: 30px; width: 24px"
                                true-value="1"
                                false-value="0"
                                v-model="detail.is_invester" />
                            </div>
                          </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                          <!-- Reports to Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label for="inputRole">Reports to</label>
                            <Multiselect
                              mode="single"
                              trackBy="executive_name"
                              label="executive_name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.report_to_name_id"
                              :options="executiveList"
                              searchable="true"
                              @search-change="searchexecutiveName($event)">
                              <template v-slot:option="{ option }">
                                <div class="col-12 row" style="padding: 0">
                                  <div class="col-10">
                                    <img
                                      class="option-icon"
                                      :src="option.executive_logo ? option.executive_logo : '/img/user-pic.png'" />
                                    {{ option.executive_name }}
                                  </div>
                                  <div class="col-1">
                                    <img
                                      class="option-icon2"
                                      :src="
                                        option.new_company && option.new_company.company_logo
                                          ? option.new_company.company_logo
                                          : '/img/user-pic.png'
                                      "
                                      :title="
                                        option.new_company && option.new_company.company_name
                                          ? option.new_company.company_name
                                          : ''
                                      " />
                                  </div>
                                </div>
                              </template>
                            </Multiselect>
                          </div>
                          <!-- Age Range Dropdown -->
                          <div class="form-group my-2 w-20 mr-3">
                            <label>Age Range</label>
                            <Field
                              type="text"
                              name="age_range_name"
                              placeholder="Select"
                              v-model="detail.age_range_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="age_range_name"
                                label="age_range_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.age_range_id"
                                :options="aagerangeList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                          <!-- <div class="form-group col-6">
                            <label>Bio Source Url</label>
                            <Field
                              type="text"
                              class="form-control"
                              name="source_url"
                              placeholder="Bio Source Url"
                              v-model="detail.source_url"
                              rules="website" />
                          </div>                           -->
                          <div class="form-group my-2 w-20 mr-3">&nbsp;</div>
                          <div class="form-group my-2 w-20 mr-3">&nbsp;</div>
                          <div class="form-group my-2 w-20 mr-3">&nbsp;</div>
                        </div>
                        <!-- New sequence end -->

                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button id="save-button-executive-details" type="submit" class="save-btn px-4 ml-3">
                            Save
                          </button>
                        </div>
                      </div>
                    </Form>
                    <!-- Tab 1 end here -->
                    <!-- Tab 2 start here -->
                    <Form @submit="saveExecutiveCareerHistory" ref="executiveCareerHistoryForm">
                      <div class="row" v-if="activeTab === 2">
                        <!-- Company Name dropdown -->
                        <div class="form-group col-3 my-2">
                          <label>Company Name</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            name="new_company_id"
                            placeholder="Select"
                            rules="required: new company"
                            v-model="detail.new_company_id"
                            :validateOnInput="true"
                            v-slot="{ field }">
                            <Multiselect
                              mode="single"
                              trackBy="company_name"
                              label="company_name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.new_company_id"
                              :options="companyList"
                              searchable="true"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false">
                              <template v-slot:option="{ option }">
                                <img
                                  class="option-icon"
                                  :src="option.company_logo ? option.company_logo : '/img/user-pic.png'" />
                                {{ option.company_name }}
                              </template>
                            </Multiselect>
                          </Field>
                          <ErrorMessage name="new_company_id" class="text-danger" />
                        </div>
                        <!-- Industry Dropdown -->
                        <div class="form-group col-3 my-2">
                          <label>Industry</label>
                          <Field
                            type="text"
                            name="industry_id_new"
                            placeholder="Select"
                            v-model="detail.industry_id_new"
                            v-slot="{ field }">
                            <Multiselect
                              style="margin-top: -3px"
                              mode="single"
                              trackBy="industry_name"
                              label="industry_name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.industry_id_new"
                              :options="industryList"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false" />
                          </Field>
                        </div>
                        <!-- Past Company dropdown -->
                        <div class="form-group col-3 my-2">
                          <label>Past Company</label>
                          <Field
                            type="text"
                            name="prev_company_id"
                            placeholder="Select"
                            v-model="detail.prev_company_id"
                            v-slot="{ field }">
                            <Multiselect
                              mode="single"
                              trackBy="company_name"
                              label="company_name"
                              valueProp="id"
                              placeholder="Select Previous Company"
                              v-model="detail.prev_company_id"
                              :options="companyList"
                              searchable="true"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false">
                              <template v-slot:option="{ option }">
                                <img
                                  class="option-icon"
                                  :src="option.company_logo ? option.company_logo : '/img/user-pic.png'" />
                                {{ option.company_name }}
                              </template>
                            </Multiselect>
                          </Field>
                        </div>

                        <!-- Past Industry dropdown -->
                        <div class="form-group col-3 my-2">
                          <label>Past Industry</label>
                          <Field
                            type="text"
                            name="industry_id_prev"
                            placeholder="Select"
                            v-model="detail.industry_id_prev"
                            v-slot="{ field }">
                            <Multiselect
                              mode="single"
                              trackBy="industry_name"
                              label="industry_name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.industry_id_prev"
                              :options="industryList"
                              searchable="true"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false" />
                          </Field>
                        </div>
                        <div class="form-group col-3">
                          <!-- Education Qualification dropdown -->
                          <div class="form-group">
                            <label>Education Qualification</label>
                            <Field
                              type="text"
                              name="EducationList"
                              placeholder="Select"
                              v-model="detail.education_id"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="education_name"
                                label="education_name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.education_id"
                                :options="EducationList"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                        </div>
                        <div class="form-group col-3 my-2">
                          <!-- Specialization in field -->
                          <div class="form-group">
                            <label>Specialization in</label>
                            <Field
                              type="text"
                              class="form-control"
                              name="Specialization"
                              placeholder="Specialization in"
                              v-model="detail.specialzation" />
                          </div>
                        </div>
                        <div class="form-group col-3 my-2">
                          <!-- Name of Education Institution dropdown -->
                          <div class="form-group">
                            <label>Name of Education Institution</label>
                            <!-- <Field
                                  type="text"
                                  class="form-control"
                                  name="Name_of_Education_Institution"
                                  placeholder="Name of Education Institution"
                                  v-model="detail.education_institutre_name"
                              /> -->

                            <Field
                              type="text"
                              name="university"
                              placeholder="Select"
                              v-model="detail.education_institutre_name"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="name"
                                label="name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.education_institutre_name"
                                :options="universitylist"
                                searchable="true"
                                v-bind="field" />
                            </Field>
                          </div>
                        </div>
                        <!-- IndusrtyExposure(More Past Company) dropdown -->
                        <div class="w-100"></div>
                        <h5 class="sub-heading col-lg-12 mb-3">Industry Exposure</h5>

                        <div v-for="(row, index) in detail.executive_compan" :key="index" class="col-12 row mt-0">
                          <!-- COMPANY DROPDOWN -->
                          <div class="col-3 form-group mb-2">
                            <Multiselect
                              mode="single"
                              trackBy="company_name"
                              label="company_name"
                              valueProp="id"
                              v-model="row.company_id"
                              :options="morePastCompanyList"
                              placeholder="Select company"
                              searchable="true"
                              @change="onPastCompanySelect($event, row)"
                              @search-change="searchPastCompanyName($event)"
                              >
                              <template v-slot:option="{ option }">
                                <img
                                  class="option-icon"
                                  :src="option.company_logo ? option.company_logo : '/img/user-pic.png'" />
                                {{ option.company_name }}
                              </template>
                            </Multiselect>
                          </div>

                          <!-- INDUSTRY NAME (AUTO-FILLED) -->
                          <div class="col-3 form-group mb-2">
                            <input
                              type="text"
                              class="form-control"
                              :name="'industry_' + index"
                              placeholder="Industry"
                              v-model="row.company.industry.industry_name"
                              readonly />
                          </div>

                          <!-- SUBSECTOR NAME (AUTO-FILLED) -->
                          <div class="col-3 form-group mb-2">
                            <input
                              type="text"
                              class="form-control"
                              :name="'subsector_' + index"
                              placeholder="Subsector"
                              :value="row.company.subsector?.industry_name"
                              readonly />
                          </div>

                          <!-- ADD / REMOVE BUTTONS -->
                          <div class="col-2 d-flex align-items-center" style="height: 35px">
                            <img
                              v-if="index === 0"
                              src="/img/plus.png"
                              width="30"
                              height="30"
                              @click="addMorePastCompanyObj"
                              style="cursor: pointer" />

                            <img
                              v-else
                              src="/img/cross.png"
                              width="30"
                              height="30"
                              @click="removeMorePastCompanyObj(index)"
                              style="cursor: pointer" />
                          </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button id="save-button-executive-career-history" type="submit" class="save-btn px-4 ml-3">
                            Save
                          </button>
                        </div>
                      </div>
                    </Form>
                    <!-- Tab 2 end here -->
                    <!-- Tab 3 start here -->
                    <Form @submit="saveExecutivxeBioSourceResponsibility" ref="executiveBiographyResponsibilityForm">
                      <div class="row" v-if="activeTab === 3">
                        <!-- Bio Source URL stays above everything -->
                        <div class="col-md-12 px-0">
                          <div class="form-group col-6">
                            <label>Bio Source Url</label>
                            <Field
                              type="text"
                              class="form-control"
                              name="source_url"
                              placeholder="Bio Source Url"
                              v-model="detail.source_url"
                              rules="website"
                              :validateOnInput="true" />
                            <ErrorMessage name="source_url" class="text-danger" />
                          </div>
                        </div>

                        <!-- 2 COLUMN LAYOUT STARTS HERE -->
                        <div class="col-md-6">
                          <!-- BIOGRAPHY -->
                          <div class="form-group">
                            <label>Biography</label>
                            <button type="button" class="biography-buttn px-3 ml-2 mb-2" @click="createExecutiveBio()">
                              Create Bio
                            </button>
                            <div
                              v-if="!isEditing"
                              class="form-control"
                              style="height: 125px; overflow-y: auto; white-space: pre-wrap; background: #f9f9f9"
                              v-html="highlightedBiography || escapeHtml(detail.executive_biography)"></div>

                            <textarea
                              v-else
                              class="form-control"
                              style="height: 125px"
                              v-model="detail.executive_biography"></textarea>

                            <div class="mt-2 d-flex justify-content-end gap-2">
                              <button type="button" class="biography-buttn px-3" v-on:click="onToggleHighlight()">
                                {{ isEditing ? "Show Highlight" : "Highlight Entities" }}
                              </button>

                              <button type="button" class="biography-buttn px-3 ml-2" @click="prefillDropdownsOnly()">
                                Prefill Dropdowns
                              </button>
                            </div>
                          </div>

                          <!-- RESPONSIBILITY -->
                          <div class="form-group mt-4">
                            <label>Current Responsibility</label>

                            <div
                              v-if="!isEditingResponsibility"
                              class="form-control"
                              style="height: 125px; overflow-y: auto; white-space: pre-wrap; background: #f9f9f9"
                              v-html="highlightedResponsibility || escapeHtml(detail.current_responsibility)"></div>

                            <textarea
                              v-else
                              class="form-control"
                              style="height: 125px"
                              v-model="detail.current_responsibility"></textarea>

                            <div class="mt-2 d-flex justify-content-end gap-2">
                              <button
                                type="button"
                                class="biography-buttn px-3"
                                @click="onToggleHighlightResponsibility()">
                                {{ isEditingResponsibility ? "Show Highlight" : "Highlight Entities" }}
                              </button>

                              <button
                                type="button"
                                class="biography-buttn px-3 ml-2"
                                @click="prefillResponsibilityDropdownsOnly()">
                                Prefill Dropdowns
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- RIGHT SIDE DROPDOWNS -->
                        <div class="col-md-6">
                          <!-- Hobbies & Interest editable dropdown -->
                          <div class="form-group skill-multiselect-tag">
                            <label>Hobbies & Interest</label>
                            <Field name="hobby_ids" v-slot="{ field }">
                              <!-- searchable="true" -->
                              <Multiselect
                                mode="tags"
                                track-by="id"
                                label="name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.hobby_ids"
                                :options="hobby_list"
                                @search-change="searchHobbyName($event)"
                                v-bind="field"
                                :showOptions="false" />
                            </Field>
                          </div>

                          <!-- Skills editable dropdown -->
                          <div class="form-group mt-3 skill-multiselect-tag">
                            <label>Skills</label>
                            <Field name="skill_ids" v-slot="{ field }">
                              <Multiselect
                                mode="tags"
                                track-by="id"
                                label="name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.skill_ids"
                                :options="skill_list"
                                @search-change="searchSkillName($event)"
                                v-bind="field"
                                :showOptions="false" />
                            </Field>
                          </div>
                          <!-- Languages editable dropdown -->
                          <div class="form-group mt-3 skill-multiselect-tag">
                            <label>Languages</label>
                            <Field name="language_ids" v-slot="{ field }">
                              <Multiselect
                                mode="tags"
                                track-by="id"
                                label="name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.language_ids"
                                :options="language_list"
                                @search-change="searchLanguageName($event)"
                                v-bind="field"
                                :showOptions="false" />
                            </Field>
                          </div>
                          <!-- Geographical Exposures editable dropdown -->
                          <div class="form-group mt-3 skill-multiselect-tag">
                            <label>Geographical Exposures</label>
                            <Field name="geographical_exposures" v-slot="{ field }">
                              <Multiselect
                                mode="tags"
                                track-by="id"
                                label="name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.geographical_exposure_ids"
                                :options="geographicalExposureList"
                                @search-change="searchGeographicalExposure($event)"
                                v-bind="field"
                                :showOptions="false" />
                            </Field>
                          </div>
                          <div style="width: 100%; text-align: right; margin-top: 4px">
                            <button type="button" class="biography-buttn px-3" @click="applyDropdowns(true)">
                              Apply
                            </button>
                          </div>
                        </div>
                        <!-- Non-editable Hobbies & Interest -->
                        <div class="col-6 skill-multiselect-tag">
                          <label>Hobbies & Interest</label>
                          <Field name="hobby_ids" v-slot="{ field }">
                            <Multiselect
                              mode="tags"
                              track-by="id"
                              label="name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.save_hobby_ids"
                              :options="save_hobby_list"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false" />
                          </Field>
                        </div>

                        <!-- Non-editable Skills -->
                        <div class="col-6 skill-multiselect-tag">
                          <label>Skills</label>
                          <Field name="skill_ids" v-slot="{ field }">
                            <Multiselect
                              mode="tags"
                              track-by="id"
                              label="name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.save_skill_ids"
                              :options="save_skill_list"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false" />
                          </Field>
                        </div>

                        <!-- Non-editable Languages -->
                        <div class="form-group col-6 skill-multiselect-tag mt-2">
                          <label>Languages</label>
                          <Field name="language_ids" v-slot="{ field }">
                            <Multiselect
                              mode="tags"
                              track-by="id"
                              label="name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.save_language_ids"
                              :options="save_language_list"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false" />
                          </Field>
                        </div>

                        <!-- Non-editable Geographical Exposures -->
                        <div class="form-group col-6 skill-multiselect-tag mt-2">
                          <label>Geographical Exposures</label>
                          <Field name="geographical_exposures" v-slot="{ field }">
                            <Multiselect
                              mode="tags"
                              track-by="id"
                              label="name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.save_geographical_exposure_ids"
                              :options="save_geographicalExposureList"
                              v-bind="field"
                              :disabled="true"
                              :showOptions="false" />
                          </Field>
                        </div>

                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button
                            id="save-button-executive-biography-responsibility"
                            type="submit"
                            class="save-btn px-4 ml-3">
                            Save
                          </button>
                        </div>
                      </div>
                    </Form>
                    <!-- Tab 3 end here -->
                    <!-- Tab 4 start here -->
                    <Form @submit="saveExecutiveContactWebReferences" ref="executiveContactWebReferencesForm">
                      <div v-if="activeTab === 4">
                        <div v-for="(data, index) in detail.social_media" :key="index" class="col-12 row px-0">
                          <div class="form-group col-3 mb-2">
                            <Field
                              as="select"
                              class="form-control"
                              placeholder="Select Platform"
                              :name="'Platform_' + index"
                              v-model="data.platform_type">
                              <option value="" disabled>Select Platform</option>
                              <option value="LinkedIn">LinkedIn</option>
                              <option value="Facebook">Facebook</option>
                              <option value="Twitter">Twitter</option>
                              <option value="Glassdoor">Glassdoor</option>
                            </Field>
                          </div>
                          <div class="form-group col-3 mb-2">
                            <Field
                              type="text"
                              class="form-control"
                              :name="'URL_' + index"
                              placeholder="URL"
                              v-model="data.url"
                              rules="website"
                              :validateOnInput="true" />
                            <ErrorMessage :name="'URL_' + index" class="text-danger" />
                          </div>
                          <img
                            v-show="index == detail.social_media.length - 1 && detail.social_media.length <= 3"
                            v-on:click="addPlatform()"
                            src="/img/plus.png"
                            width="30"
                            height="30"
                            style="cursor: pointer" />
                          <img
                            v-show="index != detail.social_media.length - 1 || index == 3"
                            v-on:click="removePlatform(index)"
                            src="/img/cross.png"
                            width="30"
                            height="30"
                            style="cursor: pointer" />
                        </div>
                        <div class="col-12 row px-0">
                          <div class="form-group col-4">
                            <label>Executive Phone</label>
                            <Field
                              type="text"
                              name="phone"
                              placeholder="1234567890"
                              v-model="detail.executive_phone"
                              v-slot="{ field }">
                              <PhoneCode
                                id="mobile"
                                placeholder="1234567890"
                                v-model:countryCode="detail.country_code"
                                v-model="detail.executive_phone"
                                v-model:dialCode="detail.dial_code"
                                v-bind="field" />
                            </Field>
                          </div>
                          <div class="form-group col-4">
                            <label>Email(Personal)</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              type="text"
                              class="form-control"
                              name="Email_P"
                              placeholder="personal email"
                              v-model="detail.executive_email_personal"
                              rules="email"
                              :validateOnInput="true" />
                            <ErrorMessage name="Email_P" class="text-danger" />
                          </div>
                          <div class="form-group col-4">
                            <label>Email(Work)</label>
                            <Field
                              type="text"
                              class="form-control"
                              name="Email_W"
                              placeholder="work email"
                              v-model="detail.executive_email_work"
                              rules="email"
                              :validateOnInput="true" />
                            <ErrorMessage name="Email_W" class="text-danger" />
                          </div>
                        </div>
                        <div class="col-12 row" style="padding: 15px">
                          <div class="col-8 px-0">
                            <h5 class="sub-heading mb-0">Web References:</h5>
                          </div>
                          <div class="col-4 text-right" style="margin-top: -26px">
                            <button
                              type="button"
                              style="margin-top: 37px; width: 192px"
                              class="save-btn px-4 ml-3"
                              v-on:click="showPublicationPopup()">
                              Add New Publication
                            </button>
                          </div>
                          <hr />
                          <h5 class="sub-heading">Interesting Article</h5>
                          <div
                            v-for="(data, index) in detail.interting_links"
                            :key="index"
                            class="col-12 row px-0 mt-1">
                            <div class="col-2 form-group">
                              <Datepicker
                                autoApply
                                v-model="data.published_date"
                                inputFormat="dd-MM-yyyy"
                                placeholder="Published Date"
                                v-bind="field"
                                format="dd-MM-yyyy"></Datepicker>
                            </div>
                            <div class="form-group col-2">
                              <Field
                                type="text"
                                :name="'headline_' + index"
                                class="form-control"
                                placeholder="Title"
                                v-model="data.headline" />
                            </div>
                            <div class="form-group col-3">
                              <Field
                                type="text"
                                :name="'url_' + index"
                                class="form-control"
                                placeholder="Url"
                                v-model="data.url" />
                            </div>
                            <div class="col-3 form-group">
                              <Multiselect
                                mode="single"
                                trackBy="name"
                                label="name"
                                valueProp="id"
                                placeholder="Select Publication"
                                v-model="data.publication_id"
                                :options="publicationList"
                                searchable="true" />
                            </div>
                            <div class="col-1 form-group" style="margin-top: -7px">
                              <input
                                :title="'Add Company Logo'"
                                type="checkbox"
                                id="is_same_as_current"
                                name="is_same_as_current"
                                style="height: 52px; width: 27px"
                                true-value="1"
                                false-value="0"
                                v-model="data.is_company_logo" />
                            </div>
                            <div class="col-1" style="margin-top: 5px">
                              <img
                                v-show="index == 0"
                                v-on:click="addLinkObj()"
                                src="/img/plus.png"
                                width="30"
                                height="30"
                                style="cursor: pointer" />
                              <img
                                v-show="index != 0"
                                v-on:click="removeLinkObj(index)"
                                src="/img/cross.png"
                                width="30"
                                height="30"
                                style="cursor: pointer" />
                            </div>
                          </div>
                          <hr />
                          <h5 class="sub-heading">Conferences & Events</h5>
                          <div
                            v-for="(data, index) in detail.conferences_event"
                            :key="index"
                            class="col-12 px-0 row mt-1">
                            <div class="col-2 form-group">
                              <Datepicker
                                autoApply
                                v-model="data.published_date"
                                inputFormat="dd-MM-yyyy"
                                placeholder="Published Date"
                                v-bind="field"
                                format="dd-MM-yyyy"></Datepicker>
                            </div>
                            <div class="form-group col-2">
                              <Field
                                type="text"
                                :name="'title_' + index"
                                class="form-control"
                                placeholder="Title"
                                v-model="data.headline" />
                            </div>
                            <div class="form-group col-3">
                              <Field
                                type="text"
                                :name="'url1_' + index"
                                class="form-control"
                                placeholder="Url"
                                v-model="data.url" />
                            </div>
                            <div class="col-3 form-group">
                              <Multiselect
                                mode="single"
                                trackBy="name"
                                label="name"
                                valueProp="id"
                                placeholder="Select Publication"
                                v-model="data.publication_id"
                                :options="publicationList"
                                searchable="true" />
                            </div>
                            <div class="col-1 form-group" style="margin-top: -7px">
                              <div>
                                <input
                                  :title="'Add Company Logo'"
                                  type="checkbox"
                                  id="is_same_as_current"
                                  name="is_same_as_current"
                                  style="height: 52px; width: 27px"
                                  true-value="1"
                                  false-value="0"
                                  v-model="data.is_company_logo" />
                              </div>
                            </div>
                            <div class="col-1" style="margin-top: 7px">
                              <img
                                v-show="index == 0"
                                v-on:click="addEventObj()"
                                src="/img/plus.png"
                                width="30"
                                height="30"
                                style="cursor: pointer" />
                              <img
                                v-show="index != 0"
                                v-on:click="removeEventObj(index)"
                                src="/img/cross.png"
                                width="30"
                                height="30"
                                style="cursor: pointer" />
                            </div>
                          </div>
                          <hr />
                          <h5 class="sub-heading">Video</h5>
                          <div v-for="(data, index) in detail.videos" :key="index" class="col-12 px-0 row mt-1">
                            <div class="form-group col-4">
                              <Field
                                type="text"
                                :name="'title1_' + index"
                                class="form-control"
                                placeholder="Title"
                                v-model="data.title" />
                            </div>
                            <div class="form-group col-4">
                              <Field
                                type="text"
                                :name="'news_ur_' + index"
                                class="form-control"
                                placeholder="Url"
                                v-model="data.video_url" />
                            </div>
                            <img
                              v-show="index == 0"
                              v-on:click="addVideoObj()"
                              src="/img/plus.png"
                              width="30"
                              height="30"
                              style="cursor: pointer" />
                            <img
                              v-show="index != 0"
                              v-on:click="removevideoObj(index)"
                              src="/img/cross.png"
                              width="30"
                              height="30"
                              style="cursor: pointer" />
                          </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button id="save-button-executive-contact-web-references" type="submit" class="save-btn px-4">
                            Save
                          </button>
                        </div>
                      </div>
                    </Form>
                    <!-- Tab 4 end here -->

                    <!-- Tab 5 start here -->
                    <Form @submit="saveExecutiveLogo" ref="executiveLogoForm">
                      <div v-if="activeTab === 5">
                        <h3 class="sub-heading mt-4">Executive Logo:</h3>
                        <div class="col-12 mt-3 mb-3 px-0">
                          <ImagePicker
                            :src="detail.executive_logo"
                            :modelValue="detail.executive_logo"
                            @removeImage="removeImage()"
                            ref="ImagePicker" />
                        </div>
                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button id="save-button-executive-logo" type="submit" class="save-btn px-4">Save</button>
                        </div>
                      </div>
                      <!-- Tab 5 end here -->
                    </Form>

                    <!-- Tab 6 start -->
                    <Form @submit="saveExecutiveFacts" ref="executiveFactsForm">
                      <div v-if="activeTab === 6">
                        <h3 class="sub-heading mt-4">Facts</h3>

                        <div v-for="(data, index) in detail.facts" :key="index" class="col-12 row px-0 mt-2">
                          <div class="form-group col-10">
                            <Field
                              type="text"
                              class="form-control"
                              :name="'fact_' + index"
                              placeholder="Enter fact"
                              v-model="data.text" />
                          </div>

                          <div class="col-2 mt-1">
                            <!-- PLUS -->
                            <img
                              v-show="index == 0"
                              @click="addFact"
                              src="/img/plus.png"
                              width="30"
                              height="30"
                              style="cursor: pointer" />

                            <!-- CROSS -->
                            <img
                              v-show="index != 0"
                              @click="removeFact(index)"
                              src="/img/cross.png"
                              width="30"
                              height="30"
                              style="cursor: pointer" />
                          </div>
                        </div>

                        <div class="col-lg-12 col-sm-12 text-center mt-3">
                          <button id="save-button-executive-facts" type="submit" class="save-btn px-4">Save</button>
                        </div>
                      </div>
                    </Form>
                    <!-- Tab 6 end -->

                    <!--  -->
                  </div>
                </div>
                <ErrorComponentNew ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TextModal ref="textModal">
      <div class="modal-header pt-0">
        <h5 class="modal-title">Add Publication</h5>
        <button type="button" class="close" v-on:click="$refs.textModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form itemref="addPubliction" @submit="addPubliction()">
        <div class="col-12 row">
          <div class="col-6 form-group">
            <label>Publication Name</label>
            <span class="text-danger">*</span>
            <Field
              type="text"
              name="user_name"
              class="form-control"
              placeholder="Publication Name"
              v-model="detail.name"
              rules="required: publication name"
              :validateOnInput="true" />
            <ErrorMessage name="user_name" class="text-danger" />
          </div>
          <div class="col-6 form-group">
            <label>Website Url</label>
            <span class="text-danger">*</span>
            <Field
              type="text"
              name="website_url"
              class="form-control"
              placeholder="Website Url"
              v-model="detail.website_url"
              rules="required: website url |website"
              :validateOnInput="true" />
            <ErrorMessage name="website_url" class="text-danger" />
          </div>
          <div class="col-6 mt-3 mb-3">
            <label>Publication Logo</label>
            <div class="text-left">
              <ImagePicker
                :src="detail.publication_logo"
                :modelValue="detail.publication_logo"
                ref="publication_logo" />
            </div>
          </div>
          <div class="col-lg-12 col-sm-12 text-center mt-2">
            <button id="publication-button" class="save-btn px-4 ml-3">Save</button>
            <button type="button" class="fil-btn px-4 ml-3" v-on:click="$refs.textModal.closeModal" id="cancel-button">
              Cancel
            </button>
          </div>
        </div>
      </Form>
    </TextModal>
    <TextModal ref="addJobtitleModal">
      <div class="p-4">
        <h5 class="mb-3">Add Jobtitle</h5>

        <div class="form-group">
          <!-- <label>Segment Name</label> -->
          <input
            type="text"
            class="form-control"
            v-model="newJobtitleName"
            placeholder="Enter jobtitle name"
          />
        </div>
        <div>
          <label>Job Function (optional)</label>
          <Field
            type="text"
            placeholder="Select"
            name="job_function_id"
            v-model="jobfunction_id"
            v-slot="{ field }"
          >
            <Multiselect
              mode="single"
              trackBy="job_function_name"
              label="job_function_name"
              valueProp="id"
              placeholder="Select"
              v-model="jobfunction_id"
              :options="jobFunctionList"
              searchable="true"
              v-bind="field"
            />
          </Field>
          <!-- <ErrorMessage
            name="job_function_id"
            class="text-danger"
          /> -->
        </div>
        <div>
          <label>Seniority Level (optional)</label>
          <Field
            type="text"
            name="Seniority"
            placeholder="Select"
            v-model="senioritylevel_id"
            v-slot="{ field }"
          >
            <Multiselect
              mode="single"
              trackBy="seniority_name"
              label="seniority_name"
              valueProp="id"
              placeholder="Select"
              v-model="senioritylevel_id"
              :options="senioritylevelList"
              searchable="true"
              v-bind="field"
            />
          </Field>
          <!-- <ErrorMessage name="Seniority" class="text-danger" /> -->
        </div>


        <div class="text-right mt-3">
          <button class="fil-btn mr-2" @click="closeAddJobtitlePopup">
            Cancel
          </button>
          <button class="save-btn" @click="saveNewJobtitle">
            Save
          </button>
        </div>
      </div>
    </TextModal>
    <TextModal ref="addJobfunctionModal">
      <div class="p-4">
        <h5 class="mb-3">Add Jobfunction</h5>

        <div class="form-group">
          <!-- <label>Segment Name</label> -->
          <input
            type="text"
            class="form-control"
            v-model="newJobfunctionName"
            placeholder="Enter jobfunction name"
          />
        </div>

        <div class="text-right mt-3">
          <button class="fil-btn mr-2" @click="closeAddJobfunctionPopup">
            Cancel
          </button>
          <button class="save-btn" @click="saveNewJobfunction">
            Save
          </button>
        </div>
      </div>
    </TextModal>
    <TextModal ref="addSeniorityModal">
      <div class="p-4">
        <h5 class="mb-3">Add Seniority</h5>

        <div class="form-group">
          <!-- <label>Segment Name</label> -->
          <input
            type="text"
            class="form-control"
            v-model="newSeniorityName"
            placeholder="Enter seniority name"
          />
        </div>

        <div class="text-right mt-3">
          <button class="fil-btn mr-2" @click="closeAddSeniorityPopup">
            Cancel
          </button>
          <button class="save-btn" @click="saveNewSeniority">
            Save
          </button>
        </div>
      </div>
    </TextModal>
    <TextModal ref="addIndustryModal">
      <div class="p-4">
        <h5 class="mb-3">Add Industry</h5>

        <div class="form-group">
          <!-- <label>Segment Name</label> -->
          <input
            type="text"
            class="form-control"
            v-model="newIndustryName"
            placeholder="Enter industry name"
          />
        </div>

        <div class="text-right mt-3">
          <button class="fil-btn mr-2" @click="closeAddIndustryPopup">
            Cancel
          </button>
          <button class="save-btn" @click="saveNewIndusrty">
            Save
          </button>
        </div>
      </div>
    </TextModal>    
  </div>
</template>
<script>
import ErrorComponentNew from "@/components/ErrorComponentNew";
import TextModal from "@/components/TextModal";
import PhoneCode from "@/components/PhoneCodePicker/PhoneCode";
import { Form, Field, ErrorMessage } from "vee-validate";
import Datepicker from "@vuepic/vue-datepicker";
import ImagePicker from "@/components/ImagePicker.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import Multiselect from "@vueform/multiselect";
export default {
  name: "Add Executive",
  components: {
    Form,
    TextModal,
    Field,
    ErrorComponentNew,
    Multiselect,
    Datepicker,
    ImagePicker,
    ErrorMessage,
    PhoneCode,
  },
  computed: {
    checkLogo() {
      return this.detail.executive_logo ? false : true;
    },

    executiveOptions() { // Doing this becuase when comes from TeamExecutiveModal - the executive_name may not be in the executiveList2 options - so need to add it dynamically
      if (!this.detail.executive_name) return this.executiveList2;

      // Check if current value exists in options
      const exists = this.executiveList2.find(
        e => e.executive_name === this.detail.executive_name
      );

      if (!exists) {
        return [
          ...this.executiveList2,
          {
            executive_name: this.detail.executive_name,
            executive_logo: null,
            new_company: null,
          }
        ];
      }
      return this.executiveList2;
    }    
  },
  watch: {
    // Executive Phone ka country code hamesha Current Country se derive hota hai.
    // country_id aur countryList me se jo bhi baad me aaye, dono par sync chalta hai.
    "detail.country_id"() {
      this.syncPhoneCountryCode();
    },
    countryList() {
      this.syncPhoneCountryCode();
    },

    /**
     * When Industry changes, handle subsectors
     */
    'detail.industry_id_new': {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal) {
          this.subsectorsList = []
          this.showSubsectorDropdown = false
          this.detail.subsector_id = ""
          return
        }

        // Reset subsector only when industry actually changes
        if (oldVal && newVal !== oldVal) {
          this.detail.subsector_id = ""
        }

        this.getSubsectorList(newVal)
      }
    },

    /** 
     * When inserting via Ai team members - come from company detail "fetch team members" button
     */
    teamExecutive: {
      immediate: true,
      handler(val) {
        if (!val) return;

        this.detail = {
          ...this.getEmptyDetail(), // reset leaky state
          ...val,                  // DB / AI data wins
        };
        // this.activeTab = 1;        // reset tab per executive
      },
    },
  },
  data() {
    return {
      activeTab: 1,
      role: localStorage.getItem("role"),
      // id: this.$route.params.id,
      loader: false,
      isShow: false,
      currentcityDropdownLoader: false,
      pastcityDropdownLoader: false,
      showSubsectorDropdown: false,
      subsectorLabel: 'Subsector',
      isShowSegment: false,

      fetchSingleExecutiveFromAiLoading: false,
      aiNotFoundMessages: [],
      isPrefillCall: false,

      // using on i button - to show popover using below 2 variables
      singleExecShowOnUi: null,
      showSingleExecInfo: false,      

      /* For Highlighting Biography */
      isEditing: true,
      highlightedBiography: "",
      is_highlight_biography: false,
      scrappingResponse: null,
      /* For Highlighting Responsibility */
      isEditingResponsibility: true,
      highlightedResponsibility: "",
      scrappingResponseResponsibility: null,
      is_highlight_responsibility: false,

      executiveList2: [],
      executive_company: [],
      executiveList: [],
      skillKeyword: "",
      skill_list: [],
      executiveKeyword: "",
      hobbyKeyword: "",
      hobby_list: [],
      languageKeyword: "",
      language_list: [],
      geographicalExposureList: [],

      // for prefil non-editable multiselect dropdonw
      save_geographicalExposureList: [],
      save_hobby_list: [],
      save_language_list: [],
      save_skill_list: [],
      segmentList: [],

      geographicalExposureKeyword: "",

      singleexecutiveurl: "",
      detail: {
        id: 0,
        s3_base_url: "",  // using this when ai flow single/team
        age_range_id: 0,
        operating_committee: 0, // checkbox
        business_unit: 0, // checkbox
        report_to_name_id: "",
        profile_update_linkedin: "Y",
        is_same_as_current: 0,
        new_company_id: "",
        industry_id_new: "",
        segment_id: "",
        prev_company_id: "",
        industry_id_prev: "",
        country_id_prev: "",
        country_id: "",
        city_id: "",
        city_id_prev: "",
        region_id_new: "",
        region_id_prev: "",
        subsector_id: "",
        executive_biography: "",
        skill_ids: [],
        save_skill_ids: [],
        hobby_ids: [],
        save_hobby_ids: [],
        language_ids: [],
        save_language_ids: [],
        geographical_exposure_ids: [],
        save_geographical_exposure_ids: [],
        executive_compan: [],
        news: [{}],
        social_media: [{}],
        videos: [
          {
            video_url: "",
            title: "",
          },
        ],
        interting_links: [
          {
            published_date: null,
            publication_id: "",
            headline: "",
            url: "",
          },
        ],
        conferences_event: [
          {
            published_date: null,
            publication_id: "",
            headline: "",
            url: "",
          },
        ],
        facts: [],
      },

      selected_industry_id: [],

      subsectorsList: [],
      departureReasonList: [],
      companyList: [],
      morePastCompanyList: [],
      countryList: [],
      company_ids: [],
      executive_ids: [],
      city_ids: [],
      cityList: [],
      cityPastList: [],
      regionList: [],
      industryList: [],
      universitylist: [],
      senioritylevelList: [],
      jobFunctionList: [],
      EducationList: [],
      aagerangeList: [],
      publicationList: [],
      jobTitleList: [],
      companyKeyword: "",
      cityKeyword: "",
      company_name: "-",
      prev_company_name: "-",
      cityname: " - ",
    };
  },
  created() {
    if (!this.isTeamExecutivePopup) {
      this.id = this.$route.params.id
    }
  },
  props: {
    teamExecutive: {
      type: Object,
      default: null,
    },
    isTeamExecutivePopup: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if(this.$refs.errorComponent) this.$refs.errorComponent.updateFormLoader(true);
    this.industrylist();    
    if (this.id) {
      this.getDetail();
    } else {
      this.addFact();
      this.addMorePastCompanyObj();
      this.pastCompanyList();
      this.getskillList();
      this.getHobbyList();
      this.getlanguageList();
      this.getgeographicalExposureList();
      this.executivelist();
    }
    if (!this.id) {
      this.companylist("TRUE");
    }
    // else {
    //   this.companylist();
    // }
    this.reasonList();
    this.CountryList();
    this.listRegion();
    this.executivelist2();
    this.publicationlist();
    this.jobFunctionlist();
    this.seniorityList();
    this.educationlist();
    this.ageRangeList();
    this.getUniversitylist();
    this.getJobTitleList();
  },
  methods: {
    // Current Country ke hisaab se Executive Phone ka country code set karta hai.
    // Current Country khali ho to kuch nahi karta, PhoneCode ka India default hi rehta hai.
    syncPhoneCountryCode() {
      if (!this.detail.country_id || this.countryList.length <= 0) {
        return;
      }
      for (var i in this.countryList) {
        if (
          this.detail.country_id == this.countryList[i].id &&
          this.countryList[i].country_code
        ) {
          this.detail.country_code =
            this.countryList[i].country_code.toLowerCase();
          return;
        }
      }
    },
    getEmptyDetail() {
      return {
        id: 0,

        // checkboxes
        operating_committee: 0,
        business_unit: 0,
        is_same_as_current: 0,

        // user editable multiselects
        skill_ids: [],
        hobby_ids: [],
        language_ids: [],
        geographical_exposure_ids: [],
        executive_compan: [],

        // repeatable UI blocks
        news: [{}],
        social_media: [{}],

        videos: [
          { video_url: "", title: "" }
        ],

        interting_links: [
          {
            published_date: null,
            publication_id: "",
            headline: "",
            url: "",
          },
        ],

        conferences_event: [
          {
            published_date: null,
            publication_id: "",
            headline: "",
            url: "",
          },
        ],

        facts: [{ text: "" }],
      };
    },    
    runDropdownListWithSelectedIds(selected_ids = [], list_type) {      
      if (!selected_ids.length || !list_type) return;
      console.log(' AddExecutive:runDropdownListWithSelectedIds: listtype-', list_type);

      switch (list_type) {
        case 'COMPANY':
          this.isPrefillCall = true;
          this.company_ids = [...selected_ids]; // ✅ spread to avoid nested array
          this.companylist("TRUE");
          break;

        case 'INDUSTRY':
          this.selected_industry_id = [...selected_ids];
          this.industrylist();
          break;

        case 'CURRENT_COUNTRY_CHANGE':
          this.CityList(selected_ids[0], "NEW");
          break;

        case 'PAST_COUNTRY_CHANGE':
          this.CityList(selected_ids[0], "PAST");
          break;

        // No need todo for both becuase in backend they don't have the limit in listing api

        // case 'JOB_FUNCTION':
        //   this.selected_jobfunction_ids = selected_ids;
        //   this.jobFunctionlist();
        //   break;

        // case 'SENIORITY_LEVEL':
        //   this.selected_senioritylevel_ids = selected_ids;
        //   this.seniorityList();
        //   break;

        
        // case 'COUNTRY':
        //   this.selected_country_ids = selected_ids;
        //   this.CountryList();
        //   break;

        // case 'JOB_TITLE':
        //   this.selected_jobtitle_ids = selected_ids;
        //   this.getJobTitleList();
        //   break;
      }
      var changeTabTo = 1;
      this.changeTabAndScrollTop(changeTabTo);
    },
    openAddJobtitlePopup() {
      this.newJobtitleName = "";
      this.jobfunction_id = "";
      this.senioritylevel_id = "";
      this.$refs.addJobtitleModal.showModal();
    },
    closeAddJobtitlePopup() {
      this.$refs.addJobtitleModal.closeModal();
    },
    saveNewJobtitle() {
      if (!this.newJobtitleName) {
        this.$notify({
          type: "error",
          text: "Please enter Jobtitle first",
        });
      }
      this.jobTitleList = [];
      var obj = {};
      obj.title = this.newJobtitleName;
      obj.job_function_id = this.jobfunction_id;
      obj.seniority_level_id = this.senioritylevel_id;
      this.$api
        .postAPI({
          _action: "/job/title",
          _body: obj,
        })
        .then((res) => {
          this.getJobTitleList();
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.closeAddJobtitlePopup();

          if (res.inserted_id) {
            this.detail.new_job_title_id = res.inserted_id;
            // this.getSeniorityDetail(res.inserted_id, 'NEW');
          }
        })
        .catch(() => {});      
    },

    openAddJobfunctionPopup() {
      this.newJobfunctionName = "";
      this.$refs.addJobfunctionModal.showModal();
    },
    closeAddJobfunctionPopup() {
      this.$refs.addJobfunctionModal.closeModal();
    },
    saveNewJobfunction() {
      if (!this.newJobfunctionName) {
        this.$notify({
          type: "error",
          text: "Please enter Jobfunction first",
        });
      }
      this.jobFunctionList = [];
      var obj = {};
      obj.job_function_name = this.newJobfunctionName;
      this.$api
        .postAPI({
          _action: "/job/function",
          _body: obj,
        })
        .then((res) => {
          this.jobFunctionlist();
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.closeAddJobfunctionPopup();

          if (res.inserted_id) {
            this.detail.job_function_id_new = res.inserted_id;            
          }
        })
        .catch(() => {});      
    },
    openAddSeniorityPopup() {
      this.newSeniorityName = "";
      this.$refs.addSeniorityModal.showModal();
    },
    closeAddSeniorityPopup() {
      this.$refs.addSeniorityModal.closeModal();
    },
    saveNewSeniority() {
      if (!this.newSeniorityName) {
        this.$notify({
          type: "error",
          text: "Please enter Seniority first",
        });
      }
      this.senioritylevelList = [];
      var obj = {};
      obj.name = this.newSeniorityName;
      this.$api
        .postAPI({
          _action: "/seniority/add",
          _body: obj,
        })
        .then((res) => {
          this.seniorityList();
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.closeAddSeniorityPopup();

          if (res.inserted_id) {
            this.detail.seniority_id = res.inserted_id;            
          }
        })
        .catch(() => {});      
    },

    openAddIndustryPopup() {
      this.newIndustryName = "";
      this.$refs.addIndustryModal.showModal();
    },
    closeAddIndustryPopup() {
      this.$refs.addIndustryModal.closeModal();
    },
    saveNewIndusrty() {
      if (!this.newIndustryName) {
        this.$notify({
          type: "error",
          text: "Please enter Industry first",
        });
      }
      this.industryList = [];
      var obj = {};
      obj.industry_name = this.newIndustryName;
      this.$api
        .postAPI({
          _action: "/industry",
          _body: obj,
        })
        .then((res) => {
          this.industrylist();
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.closeAddIndustryPopup();

          if (res.inserted_id) {
            this.detail.industry_id_new = res.inserted_id;            
          }
        })
        .catch(() => {});      
    },    

    fetchSingleExecutiveFromAi() {
      // 🔒 guard
      if (!this.singleexecutiveurl) {
        this.$notify({
          type: "error",
          text: "Please enter Url first",
        });
        return;
      }

      // 🔄 loader ON
      this.fetchSingleExecutiveFromAiLoading = true;

      const url = this.singleexecutiveurl;

      this.$api
        .postAPI({
          _action: "/fetch-single-executive-from-ai",
          _body: { url },
        })
        .then((res) => {
          if (res?.status === "success") {
            this.detail = { ...this.detail, ...res.detail }; // merge the both details
            this.detail.s3_base_url = res.detail.s3_base_url;

            // using on i button - to show popover using below 2 variables
            this.singleExecShowOnUi = res.show_on_ui || null;
            this.showSingleExecInfo = false;            

            if (res.detail.new_company_id) {
              this.runDropdownListWithSelectedIds(res.detail.new_company_id, 'COMPANY');
            }
            if (res.detail.industry_id_new) {
              this.runDropdownListWithSelectedIds(res.detail.industry_id_new, 'INDUSTRY');
            }
            if (res.detail.country_id) {
              this.runDropdownListWithSelectedIds(res.detail.country_id, 'CURRENT_COUNTRY_CHANGE');
            }
          } else {
            this.$notify({
              type: "error",
              text: res?.message || "Unable to fetch executive data",
            });
          }
        })
        .catch((err) => {
          console.error("Error calling Laravel fetch-single-executive-from-ai:", err);
          // this.$notify({
          //   type: "error",
          //   text: "Something went wrong while fetching executive data",
          // });
        })
        .finally(() => {
          // 🔄 loader OFF
          this.fetchSingleExecutiveFromAiLoading = false;
        });
    },
    prefillingAfterGetDetailCalled(res) {
      this.detail.country_id = res.country_id;
      // getDetail() poora detail object replace kar deta hai, isliye stored country_code
      // wapas aa jata hai. country_id same rehne par watcher nahi chalta, isliye yahan
      // explicitly sync karna zaroori hai.
      this.syncPhoneCountryCode();
      if (this.detail.country_id) {
        this.city_ids.push(res.city_id);
        this.CityList(this.detail.country_id, "NEW");
        this.city_ids = [];
      }

      this.detail.country_id_prev = res.country_id_prev;
      if (this.detail.country_id_prev) {
        this.city_ids.push(res.city_id_prev);
        this.CityList(this.detail.country_id_prev, "PAST");
      }
    },
    // prefilMorePastCompanyList(res) {
    //   if (res.executive_compan.length > 0) {
    //     for (var i in res.executive_compan) {
    //       this.executive_company.push(res.executive_compan[i].company_id);
    //       this.company_ids.push(res.executive_compan[i].company_id);
    //     }
    //   } else {
    //     this.addMorePastCompanyObj();
    //   }
    // },
    prefilMorePastCompanyList(res) {
      if (res.executive_compan.length > 0) {
        this.company_ids = []; // ensure clean

        res.executive_compan.forEach((row) => {
          if (row.company_id) {
            this.executive_company.push(row.company_id);
            this.company_ids.push(row.company_id);
          }
        });

        // THE IMPORTANT LINE
        this.pastCompanyList();
      } else {
        this.addMorePastCompanyObj();
      }
    },
    addMorePastCompanyObj() {
      this.detail.executive_compan.push({
        id: null,
        executive_id: this.detail.id ?? null,
        company_id: null,
        created_on: null,
        company: {
          id: null,
          industry_id: null,
          industry: {
            id: null,
            industry_name: "",
          },
          subsector: {
            id: null,
            industry_name: "",
          },
        },
      });
    },
    removeMorePastCompanyObj(index) {
      this.detail.executive_compan.splice(index, 1);
    },
    onPastCompanySelect(cid, row) {
      const selected = this.morePastCompanyList.find((x) => x.id === cid);

      if (selected) {
        row.company.id = selected.id;
        row.company.industry.id = selected.industry?.id ?? null;
        row.company.industry.industry_name = selected.industry?.industry_name ?? "";

        // Subsector (NEW)
        row.company.subsector = {
          id: selected.subsector?.id ?? null,
          industry_name: selected.subsector?.industry_name ?? "",
        };
      }
    },
    searchPastCompanyName(e) {
      if (!e) return;
      this.companyKeyword = e;
      this.pastCompanyList();
    },
    pastCompanyList() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids.length > 0) {
        obj.company_ids = this.company_ids;
      }
      this.$api
        .getAPI({
          _action: "/more-past-company/list",
          _body: obj,
        })
        .then((res) => {
          this.morePastCompanyList = res;
          this.company_ids = [];
        })
        .catch(() => {
          this.loader = false;
        });
    },
    searchHobbyName(e) {
      if (e) {
        this.hobbyKeyword = e;
        this.getHobbyList();
      }
    },
    getSaveListCommon(api, ids, assignTo) {
      const obj = {};

      if (ids && ids.length > 0) {
        obj.selected_ids = ids; // Correct key name
      }

      this.$api
        .getAPI({
          _action: api,
          _body: obj,
        })
        .then((res) => {
          this[assignTo] = res; // <-- ⭐ Correct way to assign dynamic variable
        })
        .catch(() => {});
    },
    getHobbyList() {
      var obj = {};
      if (this.hobbyKeyword) {
        obj.keyword = this.hobbyKeyword;
      }
      if (this.detail.hobby_ids?.length > 0) {
        obj.selected_ids = this.detail.hobby_ids;
      }
      this.$api
        .getAPI({
          _action: "/hobbies/list_unpaged",
          _body: obj,
        })
        .then((res) => {
          this.hobby_list = res;
          this.hobbyKeyword = "";
        })
        .catch(() => {});
    },
    changeIndustry(id, needToBlankSubsector = false) {
      if (!id) {
        this.subsectorsList = []
        this.showSubsectorDropdown = false
        this.detail.subsector_id = ""
        return
      }

      const industry = this.industryList.find(i => i.id === id)
      switch (industry?.industry_name) {
        case 'Technology':
          this.subsectorLabel = 'Tech Focus';
          if (needToBlankSubsector) this.detail.subsector_id = "";
          break
        case 'Financial Services':
          this.subsectorLabel = 'FS Focus';
          if (needToBlankSubsector) this.detail.subsector_id = "";
          break
        default:
          this.subsectorLabel = 'Subsector';
          this.detail.subsector_id = "";
          this.showSubsectorDropdown = false;
          return;
      }
      this.getSubsectorList(id);
    },
    getSubsectorList(id) {
      if (!id) return
      
      this.$api
        .getAPI({
          _action: `/subsectors/list/${id}`,
        })
        .then((res) => {
          this.subsectorsList = res.list || []
          this.showSubsectorDropdown = this.subsectorsList.length > 0
        })
        .catch(() => {
          this.showSubsectorDropdown = false
        })
    },
    getSeniorityDetail(id, type) {
      for (var i in this.jobTitleList) {
        if (id == this.jobTitleList[i].id) {
          if (type == "NEW") {
            this.detail.seniority_id = this.jobTitleList[i].seniority_level_id;
            this.detail.job_function_id_new = this.jobTitleList[i].job_function_id;
          }
          if (type == "PREV") {
            this.detail.seniority_id_prev = this.jobTitleList[i].seniority_level_id;
            this.detail.job_function_id_prev = this.jobTitleList[i].job_function_id;
          }
        }
      }
    },
    currentCompanyChange(id, type) {
      if (!id) return;
      this.getIndustrydetail(id, type);
      if (type == "NEW") this.getSegmentList(id);
    },
    getIndustrydetail(id, type) {
      for (var i in this.companyList) {
        if (this.companyList[i].id == id && type == "NEW") {
          this.detail.industry_id_new = this.companyList[i].industry_id;          
          this.detail.subsector_id = this.companyList[i].subsector_id;

          this.changeIndustry(this.detail.industry_id_new);
        }
        if (this.companyList[i].id == id && type == "OLD") {
          this.detail.industry_id_prev = this.companyList[i].industry_id;
        }
      }
      this.getCountrySameAsCompany("INDUSTRY");
    },
    async applyDropdowns(is_message_show = false) {
      // 1) Normalize (safety)
      this.detail.skill_ids = (this.detail.skill_ids || []).map(Number);
      this.detail.hobby_ids = (this.detail.hobby_ids || []).map(Number);
      this.detail.language_ids = (this.detail.language_ids || []).map(Number);
      this.detail.geographical_exposure_ids = (this.detail.geographical_exposure_ids || []).map(Number);

      // 2) Clear all NON-editable selected ids first (force rerender)
      this.detail.save_skill_ids = [];
      this.detail.save_hobby_ids = [];
      this.detail.save_language_ids = [];
      this.detail.save_geographical_exposure_ids = [];

      // 3) Clear NON-editable lists (force rerender)
      this.save_skill_list = [];
      this.save_hobby_list = [];
      this.save_language_list = [];
      this.save_geographicalExposureList = [];

      // Wait for UI update
      await this.$nextTick();

      // -------------------------------
      // 4) CALL BACKEND TO FETCH ONLY SELECTED OPTIONS
      // -------------------------------
      this.getSaveListCommon("/skills/list_unpaged", this.detail.skill_ids, "save_skill_list");

      this.getSaveListCommon("/hobbies/list_unpaged", this.detail.hobby_ids, "save_hobby_list");

      this.getSaveListCommon("/languages/list_unpaged", this.detail.language_ids, "save_language_list");

      this.getSaveListCommon(
        "/geo_exposures/list_unpaged",
        this.detail.geographical_exposure_ids,
        "save_geographicalExposureList"
      );

      // -------------------------------
      // 5) Next tick: assign selected IDs
      // -------------------------------
      setTimeout(() => {
        this.detail.save_skill_ids = [...this.detail.skill_ids];
        this.detail.save_hobby_ids = [...this.detail.hobby_ids];
        this.detail.save_language_ids = [...this.detail.language_ids];
        this.detail.save_geographical_exposure_ids = [...this.detail.geographical_exposure_ids];

        if (is_message_show) {
          this.$notify({
            type: "success",
            text: "Applied changes successfully.",
          });
        }
      }, 300);
    },
    onToggleHighlightResponsibility() {
      if (this.isEditingResponsibility) {
        this.isEditingResponsibility = false;
        this.highlightResponsibilityEntities();
      } else {
        this.isEditingResponsibility = true;
      }
    },
    // toggle between edit/view
    onToggleHighlight() {
      if (this.isEditing) {
        this.isEditing = false;
        this.highlightBiographyEntities();
      } else {
        this.isEditing = true;
      }
    },

    // call Laravel /scrapping API (which calls Python)
    highlightBiographyEntities() {
      const paragraph = this.detail.executive_biography?.trim();
      if (!paragraph) {
        this.highlightedBiography = "";
        return;
      }

      this.is_highlight_biography = true;

      this.$api
        .postAPI({
          _action: "/scrapping",
          _body: { paragraph },
        })
        .then((res) => {
          if (res.status === "success") {
            this.highlightedBiography = res.highlighted_biography;
            // ⭐ Save scrapping response for later use
            this.scrappingResponse = res;
          } else {
            console.warn("Unexpected response:", res);
            this.highlightedBiography = this.escapeHtml(paragraph);
          }
        })
        .catch((err) => {
          console.error("Error calling Laravel /scrapping:", err);
          this.highlightedBiography = this.escapeHtml(paragraph);
        })
        .finally(() => {
          this.is_highlight_biography = false;
        });
    },

    // safely render plain text when highlight not available
    escapeHtml(text) {
      if (!text) return "";
      return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br/>");
    },
    prefillDropdownsOnly() {
      if (!this.scrappingResponse) {
        this.$notify({
          type: "error",
          text: "Run highlight first to detect entities.",
        });
        return;
      }

      // ⭐ Use stored scrapping response
      this.prefillScrappingDropdowns(this.scrappingResponse);
    },
    // -----------------------------
    // 🎨 Prefill dropdowns from SCRAPPING API
    // -----------------------------
    prefillScrappingDropdowns(res) {
      console.log("prefillScrappingDropdowns called with:", res);

      // ---------------------------
      // 🔹 Skills (merge)
      // ---------------------------
      if (res.skills) {
        this.skill_list = this.mergeOptions(
          this.skill_list,
          res.skills.map((i) => ({ id: i.id, name: i.name }))
        );
      }

      const skillIds = res.skills_ids || [];
      if (Array.isArray(skillIds)) {
        this.detail.skill_ids = this.mergeIds(this.detail.skill_ids, skillIds);
      }

      // ---------------------------
      // 🔹 Hobbies (merge)
      // ---------------------------
      if (res.hobbies) {
        this.hobby_list = this.mergeOptions(
          this.hobby_list,
          res.hobbies.map((i) => ({ id: i.id, name: i.name }))
        );
      }

      const hobbyIds = res.hobbies_ids || [];
      if (Array.isArray(hobbyIds)) {
        this.detail.hobby_ids = this.mergeIds(this.detail.hobby_ids, hobbyIds);
      }

      // ---------------------------
      // 🔹 Languages (merge)
      // ---------------------------
      if (res.languages) {
        this.language_list = this.mergeOptions(
          this.language_list,
          res.languages.map((i) => ({ id: i.id, name: i.name }))
        );
      }

      const languageIds = res.languages_ids || [];
      if (Array.isArray(languageIds)) {
        this.detail.language_ids = this.mergeIds(this.detail.language_ids, languageIds);
      }

      // ---------------------------
      // 🔹 Geographical Exposures (merge)
      // ---------------------------
      if (res.geographical_exposures) {
        this.geographicalExposureList = this.mergeOptions(
          this.geographicalExposureList,
          res.geographical_exposures.map((i) => ({ id: i.id, name: i.name }))
        );
      }

      const geoIds = res.geographical_exposures_ids || [];
      if (Array.isArray(geoIds)) {
        this.detail.geographical_exposure_ids = this.mergeIds(this.detail.geographical_exposure_ids, geoIds);
      }
    },
    prefillResponsibilityDropdownsOnly() {
      if (!this.scrappingResponseResponsibility) {
        this.$notify({
          type: "error",
          text: "Run highlight on responsibility first.",
        });
        return;
      }

      this.prefillScrappingDropdowns(this.scrappingResponseResponsibility);
    },
    highlightResponsibilityEntities() {
      const paragraph = this.detail.current_responsibility?.trim();
      if (!paragraph) {
        this.highlightedResponsibility = "";
        return;
      }

      this.$api
        .postAPI({
          _action: "/scrapping",
          _body: { paragraph },
        })
        .then((res) => {
          if (res.status === "success") {
            this.highlightedResponsibility = res.highlighted_biography;
            this.scrappingResponseResponsibility = res;
            this.isEditingResponsibility = false; // ⭐ important
          } else {
            this.highlightedResponsibility = this.escapeHtml(paragraph);
          }
        })
        .catch(() => {
          this.highlightedResponsibility = this.escapeHtml(paragraph);
        });
    },
    // Merge options uniquely (by id)
    mergeOptions(existing = [], incoming = []) {
      const map = new Map();

      existing.forEach((item) => {
        if (item && item.id) map.set(item.id, item);
      });

      incoming.forEach((item) => {
        if (item && item.id) map.set(item.id, item);
      });

      return Array.from(map.values());
    },

    // Merge IDs uniquely
    mergeIds(target = [], incoming = []) {
      // Normalize existing IDs first
      let normalized = target.map((id) => Number(id)).filter((id) => !isNaN(id));
      const set = new Set(normalized);

      incoming.forEach((id) => {
        const num = Number(id);
        if (!set.has(num)) {
          set.add(num);
          normalized.push(num); // mutation of new array, not target
        }
      });

      return normalized;
    },
    createExecutiveBio() {
      this.getCompamyName("NEW");
      this.getCompamyName("OLD");
      this.getCityName();

      var executive = this.detail.executive_name ? this.detail.executive_name : "Executive ";
      var job_title = "-";

      if (this.$helperService.isStringOnlyAlphabet(this.detail.new_job_title_id)) {
        job_title = this.detail.new_job_title_id;
      } else {
        for (var a in this.jobTitleList) {
          if (this.detail.new_job_title_id == this.jobTitleList[a].id) {
            job_title = this.jobTitleList[a].title;
          }
        }
      }

      var gender = this.detail.gender == "male" ? "He" : this.detail.gender == "female" ? "She" : "-";
      var prev_job_title = "-";

      if (this.$helperService.isStringOnlyAlphabet(this.detail.prev_job_title_id)) {
        prev_job_title = this.detail.prev_job_title_id;
      } else {
        for (var b in this.jobTitleList) {
          if (this.detail.prev_job_title_id == this.jobTitleList[b].id) {
            prev_job_title = this.jobTitleList[b].title;
          }
        }
      }
      var degree = "-";
      for (var i in this.EducationList) {
        if (this.detail.education_id == this.EducationList[i].id) {
          degree = this.EducationList[i].education_name;
        }
      }
      var specialzation = this.detail.specialzation ? this.detail.specialzation : "-";
      var education_institutre_name = "-";
      for (var j in this.universitylist) {
        if (this.detail.education_institutre_name == this.universitylist[j].id) {
          education_institutre_name = this.universitylist[j].name;
        }
      }
      var country_name = "-";
      for (var k in this.countryList) {
        if (this.detail.country_id == this.countryList[k].id) {
          country_name = this.countryList[k].country_name;
        }
      }
      setTimeout(() => {
        var bio =
          executive +
          " serves as " +
          job_title +
          " at " +
          this.company_name +
          ". " +
          gender +
          " previously served as a " +
          prev_job_title +
          " at " +
          this.prev_company_name +
          ". " +
          "\n\n" +
          gender +
          " holds a " +
          degree +
          " in " +
          specialzation +
          " from the " +
          education_institutre_name +
          ". " +
          "\n\n" +
          "Currently based at " +
          this.cityname +
          country_name +
          ".";

        this.detail.executive_biography = bio;
      }, 2300);
    },
    getCityName() {
      var obj = {};
      if (this.detail.city_id) {
        obj.name = this.detail.city_id;
      }
      this.$api
        .getAPI({
          _action: "/city/list",
          _body: obj,
        })
        .then((res) => {
          if (res.city_name) {
            this.cityname = res.city_name + ", ";
          }
        })
        .catch(() => {});
    },
    removeImage() {
      if (this.id) {
        this.$api
          .postAPI({
            _action: "/remove-executive-image/" + this.id,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getDetail();
          })
          .catch(() => {});
      } else {
        this.detail.executive_logo = "";
        // // console.log("this.detail.user_images after", index);
      }
    },
    getCompamyName(type) {
      var obj = {};
      if (this.detail.new_company_id && type == "NEW") {
        obj.name = this.detail.new_company_id;
      }
      if (this.detail.prev_company_id && type == "OLD") {
        obj.name = this.detail.prev_company_id;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          if (res.company_name) {
            if (type == "NEW") {
              this.company_name = res.company_name;
              return;
            }
          }
          if (res.company_name) {
            if (type == "OLD") {
              this.prev_company_name = res.company_name;
              return;
            }
          }
        })
        .catch(() => {});
    },
    getPrevCompamyName() {
      var obj = {};
      if (this.detail.prev_company_id) {
        obj.name = this.detail.prev_company_id;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          this.prev_company_name = res.company_name;
          return;
        })
        .catch(() => {});
    },
    getCountrySameAsCompany(type) {
      if (this.detail.is_hq_based == 1) {
        if (this.detail.new_company_id) {
          this.$api
            .getAPI({
              _action: "/company/detail/" + this.detail.new_company_id,
            })
            .then((res) => {
              this.detail.country_id = res.country_id;
              this.detail.region_id_new = res.region_id;
              this.detail.city_id = res.city_id;
              this.city_ids.push(this.detail.city_id);
              this.detail.executive_phone = res.company_mobile;
              this.detail.country_code = res.country_code;
              this.detail.dial_code = res.dial_code;
              if (this.detail.is_same_as_current == 1) {
                this.detail.country_id_prev = this.detail.country_id;
                this.detail.region_id_prev = this.detail.region_id_new;
                this.detail.city_id_prev = this.detail.city_id;
              }

              this.CityList(this.detail.country_id, type);
              return;
            })
            .catch(() => {});
        }

        if (this.detail.is_same_as_current == 1) {
          this.detail.country_id_prev = this.detail.country_id;
          this.detail.region_id_prev = this.detail.region_id_new;
          this.detail.city_id_prev = this.detail.city_id;
        }
      }
      if (this.detail.is_hq_based == 0) {
        // this.detail.country_id = "";
        // this.detail.region_id_new = "";
        // this.detail.city_id = "";
      }
      this.CityList(this.detail.country_id, type);
    },
    getsameCountry(id, type) {
      if (type == "NEW") {
        this.detail.city_id = "";
      }
      if (type == "PAST") {
        this.detail.city_id_prev = "";
      }
      if (this.detail.is_same_as_current == 1) {
        this.detail.country_id_prev = id;
      }
      for (var j in this.countryList) {
        if (id == this.countryList[j].id) {
          if (this.detail.is_same_as_current == 1 || type == "PAST") {
            this.detail.region_id_prev = this.countryList[j].region_id;
          }
          if (type == "NEW") {
            this.detail.country_code = this.countryList[j].country_code;
            this.detail.region_id_new = this.countryList[j].region_id;
          }
        }
      }
      this.CityList(id, type);
    },
    CityList(country_id, type) {
      if (type == "INDUSTRY" || type) {
        type == "NEW" ? (this.currentcityDropdownLoader = true) : "";
        type == "PAST" ? (this.pastcityDropdownLoader = true) : "";
      }
      var obj = {};
      if (this.cityKeyword) {
        obj.keyword = this.cityKeyword;
      }
      if (this.city_ids.length > 0) {
        obj.city_ids = this.city_ids;
      }
      if (country_id) {
        obj.country_id = country_id;

        // for (var i in this.countryList) {
        //   if (country_id == this.countryList[i].id) {
        //     this.detail.country_code = this.countryList[i].country_code;
        //   }
        // }
      }
      // if (this.detail.country_id) {
      //   // obj.country_id = this.detail.country_id;
      //   for (var j in this.countryList) {
      //     if (this.detail.country_id == this.countryList[j].id) {
      //       this.detail.country_code = this.countryList[j].country_code;
      //     }
      //   }
      // }
      // if (this.detail.country_id_prev) {
      //   obj.country_id = this.detail.country_id_prev;
      //   for (var k in this.countryList) {
      //     if (this.detail.country_id_prev == this.countryList[k].id) {
      //       this.detail.country_code = this.countryList[k].country_code;
      //     }
      //   }
      // }
      if (this.detail.country_id || this.detail.country_id_prev || type) {
        this.$api
          .getAPI({
            _action: "/city/list",
            _body: obj,
          })
          .then((res) => {
            if (type == "NEW") {
              this.cityList = res;
            } else if (type == "PAST") {
              this.cityPastList = res;
            } else {
              this.cityList = res;
              this.cityPastList = res;
            }
            this.city_ids = [];
            this.cityKeyword = "";
            if (type == "INDUSTRY" || type) {
              this.loader = false;
              type == "NEW" ? (this.currentcityDropdownLoader = false) : (this.pastcityDropdownLoader = false);
            }
          })
          .catch(() => {
            this.loader = false;

            type == "NEW" ? (this.currentcityDropdownLoader = false) : (this.pastcityDropdownLoader = false);
          });
      } else {
        this.detail.city_id = "";
        this.detail.city_id_prev = "";
        this.$notify({
          type: "error",
          text: "Please Select Country First.",
        });
      }
    },
    getsameRegion(id) {
      if (this.detail.is_same_as_current == 1) {
        this.detail.region_id_prev = id;
      }
    },
    getsameCity(id) {
      if (this.detail.is_same_as_current == 1) {
        this.detail.city_id_prev = id;
      }
    },
    getSameAsCurrent(value) {
      if (value == 1) {
        if (this.detail.country_id) {
          this.detail.country_id_prev = this.detail.country_id;
        }
        if (this.detail.region_id_new) {
          this.detail.region_id_prev = this.detail.region_id_new;
        }
        if (this.detail.city_id) {
          this.detail.city_id_prev = this.detail.city_id;
        }
      }
    },
    searchCompanyName(e, type) {
      // if (!e) return;
      this.companyKeyword = e;
      this.companylist(type);
    },
    searchCityName(e) {
      if (!e) return;
      this.cityKeyword = e;
      this.CityList(this.detail.country_id);
    },
    searchexecutiveName(e) {
      if (!e) return;
      this.executiveKeyword = e;
      this.executivelist();
    },
    searchexecutiveName2(e) {
      if (!e) return;
      this.executiveKeyword = e;
      this.executivelist2();
    },
    addPlatform() {
      if (this.detail.social_media.length < 5) {
        this.detail.social_media.push({});
      }
    },
    removePlatform(index) {
      this.detail.social_media.splice(index, 1);
    },
    addEventObj() {
      this.detail.conferences_event.push({});
    },
    removeEventObj(index) {
      this.detail.conferences_event.splice(index, 1);
    },
    addLinkObj() {
      this.detail.interting_links.push({});
    },
    removeLinkObj(index) {
      this.detail.interting_links.splice(index, 1);
    },
    addNewsObj() {
      this.detail.news.push({});
    },
    removeNewsObj(index) {
      this.detail.news.splice(index, 1);
    },
    addVideoObj() {
      this.detail.videos.push({});
    },
    removevideoObj(index) {
      this.detail.videos.splice(index, 1);
    },
    executivelist2() {
      var obj = {};
      if (this.executiveKeyword) {
        obj.keyword = this.executiveKeyword;
      }
      this.$api
        .getAPI({
          _action: "/executive/list",
          _body: obj,
        })
        .then((res) => {
          this.executiveList2 = res;
          this.executiveKeyword = "";
          for (var a in this.executiveList2) {
            this.executiveList2[a].disabled = false;
          }
          for (var i in this.executiveList2) {
            if (this.executiveList2[i].executive_name) {
              this.executiveList2[i].name = this.executiveList2[i].executive_name;
            }
            if (this.executiveList2[i].new_job_title) {
              this.executiveList2[i].name += ", " + this.executiveList2[i].new_job_title;
            }
            if (this.executiveList2[i].new_company) {
              this.executiveList2[i].name += ", " + this.executiveList2[i].new_company.company_name;
            }
          }
        })
        .catch(() => {});
    },
    executivelist() {
      var obj = {};
      if (this.executiveKeyword) {
        obj.keyword = this.executiveKeyword;
      }
      if (this.executive_ids.length > 0) {
        obj.executive_ids = this.executive_ids;
      }
      this.$api
        .getAPI({
          _action: "/executive/list",
          _body: obj,
        })
        .then((res) => {
          this.executiveList = res;
          this.executiveKeyword = "";
          this.executive_ids = [];
          for (var i in this.executiveList) {
            if (this.executiveList[i].executive_name) {
              this.executiveList[i].name = this.executiveList[i].executive_name;
            }
            if (this.executiveList[i].new_job_title) {
              this.executiveList[i].name += ", " + this.executiveList[i].new_job_title;
            }
            if (this.executiveList[i].new_company) {
              this.executiveList[i].name += ", " + this.executiveList[i].new_company.company_name;
            }
          }
        })
        .catch(() => {});
    },
    publicationlist() {
      var obj = {};
      if (this.publicationKeyword) {
        obj.keyword = this.publicationKeyword;
      }
      this.$api
        .getAPI({
          _action: "/publications/list",
          _body: obj,
        })
        .then((res) => {
          this.publicationList = res;
        })
        .catch(() => {});
    },
    getJobTitleList() {
      this.$api
        .getAPI({
          _action: "/job/title/list",
        })
        .then((res) => {
          this.jobTitleList = res;

          if (this.detail.new_job_title_id) {
            if (this.$helperService.isStringOnlyAlphabet(this.detail.new_job_title_id)) {
              this.jobTitleList.push({
                title: this.detail.new_job_title_id,
                id: this.detail.new_job_title_id,
              });
            }
          }

          if (this.detail.prev_job_title_id) {
            if (this.$helperService.isStringOnlyAlphabet(this.detail.prev_job_title_id)) {
              this.jobTitleList.push({
                title: this.detail.prev_job_title_id,
                id: this.detail.prev_job_title_id,
              });
            }
          }
        })
        .catch(() => {});
    },
    getDetail(changeTabTo = "") {
      this.$api
        .getAPI({
          _action: "/executive/detail/" + this.id,
        })
        .then((res) => {
          this.prefilMorePastCompanyList(res);
          this.company_ids.push(res.new_company_id);
          this.company_ids.push(res.prev_company_id);

          // Prefilling report to dropdonw
          this.executive_ids.push(res.report_to_name_id);
          this.executivelist();

          this.detail = res;
          this.prefillingAfterGetDetailCalled(res);

          if (this.$helperService.isStringOnlyAlphabet(res.new_job_title_id)) {
            this.detail.new_job_title_id = res.new_job_title_id;
            this.jobTitleList.push({
              id: res.new_job_title_id, // keep the same string
              title: res.new_job_title_id,
            });
          }
          if (this.$helperService.isStringOnlyAlphabet(res.prev_job_title_id)) {
            this.detail.prev_job_title_id = res.prev_job_title_id;
            this.jobTitleList.push({
              id: res.prev_job_title_id, // keep the same string
              title: res.prev_job_title_id,
            });
          }

          // Prefill skills IDs only
          if (res.executive_skills && Array.isArray(res.executive_skills)) {
            this.detail.skill_ids = res.executive_skills.map((item) => item.skill_id);
            this.getskillList();
          }

          // Prefill hobbies IDs only (Editable Dropdown)
          if (res.executive_hobbies && Array.isArray(res.executive_hobbies)) {
            this.detail.hobby_ids = res.executive_hobbies.map((item) => item.hobby_id);
            this.getHobbyList();
          }

          // Prefill languages IDs only (Editable Dropdown)
          if (res.executive_languages && Array.isArray(res.executive_languages)) {
            this.detail.language_ids = res.executive_languages.map((item) => item.language_id);
            this.getlanguageList();
          }

          // Prefill geographical exposures IDs only (Editable Dropdown)
          if (res.executive_geographical_exposures && Array.isArray(res.executive_geographical_exposures)) {
            this.detail.geographical_exposure_ids = res.executive_geographical_exposures.map(
              (item) => item.geographical_exposure_id
            );
            this.getgeographicalExposureList();
          }

          this.applyDropdowns(); //  after prefill the editable dropdonws need to prefill Non Editable too.

          if (this.detail.executive_name) {
            this.executiveKeyword = this.detail.executive_name;
            this.executivelist2();
          }

          this.detail.social_media = [];
          if (this.detail.facebook_url) {
            var obj1 = {
              platform_type: "Facebook",
              url: this.detail.facebook_url,
            };
            this.detail.social_media.push(obj1);
          }
          if (this.detail.twitter_url) {
            var obj2 = {
              platform_type: "Twitter",
              url: this.detail.twitter_url,
            };
            this.detail.social_media.push(obj2);
          }
          if (this.detail.linkedin_url) {
            var obj3 = {
              platform_type: "LinkedIn",
              url: this.detail.linkedin_url,
            };
            this.detail.social_media.push(obj3);
          }
          if (this.detail.glassdoor_url) {
            var obj4 = {
              platform_type: "Glassdoor",
              url: this.detail.glassdoor_url,
            };
            this.detail.social_media.push(obj4);
          }
          if (this.detail.social_media.length == 0) {
            this.detail.social_media.push({});
          }
          if (this.detail.videos.length <= 0) {
            this.detail.videos.push({});
          }

          if (this.detail.interting_links.length <= 0) {
            this.detail.interting_links.push({
              published_date: null,
              publication_id: "",
              headline: "",
              url: "",
            });
          }
          if (this.detail.conferences_event.length <= 0) {
            this.detail.conferences_event.push({
              published_date: null,
              publication_id: "",
              headline: "",
              url: "",
            });
          }
          if (this.detail.news.length <= 0) {
            this.detail.news.push({});
          }

          this.searchexecutiveName();
          this.searchCityName();
          this.searchCompanyName(null, "TRUE");
          if (changeTabTo) {
            this.changeTabAndScrollTop(changeTabTo);
          }
          if (
            !this.detail.executive_compan ||
            (this.detail.executive_compan && this.detail.executive_compan.length == 0)
          ) {
            this.addMorePastCompanyObj();
          }

          this.prefillFacts(res);

          if (res.new_company_id) {
            this.getSegmentList(res.new_company_id);
          }

          if (res.industry_id_new) {
            this.detail.subsector_id = res.subsector_id ?? "";
            this.changeIndustry(res.industry_id_new);
          }
        })
        .catch(() => {});
    },
    ageRangeList() {
      this.$api
        .getAPI({
          _action: "/age/range/list",
        })
        .then((res) => {
          this.aagerangeList = res;
        })
        .catch(() => {});
    },
    getSegmentList(id) {
      if (!id) {
        this.isShowSegment = false;
        return;
      }
      this.$api
        .getAPI({
          _action: "/segments/list_unpaged/" + id,
        })
        .then((res) => {
          this.segmentList = res;

          // Only show segment dropdown if there are segment(of company) available
          if (this.segmentList.length > 0) {
            this.isShowSegment = true;
          } else {
            this.isShowSegment = false;
          }
        })
        .catch(() => {
          this.isShowSegment = false;
        });
    },
    searchSkillName(e) {
      if (e) {
        this.skillKeyword = e;
        this.getskillList();
      }
    },
    getskillList() {
      var obj = {};
      if (this.skillKeyword) {
        obj.keyword = this.skillKeyword;
      }
      if (this.detail.skill_ids?.length > 0) {
        obj.selected_ids = this.detail.skill_ids;
      }
      this.$api
        .getAPI({
          _action: "/skills/list_unpaged",
          _body: obj,
        })
        .then((res) => {
          this.skill_list = res;
          this.skillKeyword = "";
        })
        .catch(() => {});
    },
    searchLanguageName(e) {
      if (e) {
        this.languageKeyword = e;
        this.getlanguageList();
      }
    },
    getlanguageList() {
      var obj = {};
      if (this.languageKeyword) {
        obj.keyword = this.languageKeyword;
      }
      if (this.detail.language_ids?.length > 0) {
        obj.selected_ids = this.detail.language_ids;
      }
      this.$api
        .getAPI({
          _action: "/languages/list_unpaged",
          _body: obj,
        })
        .then((res) => {
          this.language_list = res;
          this.languageKeyword = "";
        })
        .catch(() => {});
    },
    searchGeographicalExposure(e) {
      if (e) {
        this.geographicalExposureKeyword = e;
        this.getgeographicalExposureList();
      }
    },
    getgeographicalExposureList() {
      var obj = {};
      if (this.geographicalExposureKeyword) {
        obj.keyword = this.geographicalExposureKeyword;
      }
      if (this.detail.geographical_exposure_ids?.length > 0) {
        obj.selected_ids = this.detail.geographical_exposure_ids;
      }
      this.$api
        .getAPI({
          _action: "/geo_exposures/list_unpaged",
          _body: obj,
        })
        .then((res) => {
          this.geographicalExposureList = res;
          this.geographicalExposureKeyword = "";
        })
        .catch(() => {});
    },
    getUniversitylist() {
      this.$api
        .getAPI({
          _action: "/university/list",
        })
        .then((res) => {
          this.universitylist = res;
        })
        .catch(() => {});
    },
    educationlist() {
      this.$api
        .getAPI({
          _action: "/education/list",
        })
        .then((res) => {
          this.EducationList = res;
        })
        .catch(() => {});
    },

    industrylist() {
      var obj = {};
      if (this.industryKeyword) {
        obj.keyword = this.industryKeyword;
      }
      if (this.selected_industry_id) {
        obj.selected_ids = this.selected_industry_id;
      }
      this.$api
        .getAPI({
          _action: "/industry/subsector-count/list", //we changed the industry list and get the count- that which industry have subsector.
          _body: obj,
        })
        .then((res) => {
          this.industryList = res;
          this.industryKeyword = "";
          this.selected_industry_id = [];
        })
        .catch(() => {});
    },
    listRegion() {
      this.$api
        .getAPI({
          _action: "/region/list",
        })
        .then((res) => {
          this.regionList = res;
        })
        .catch(() => {});
    },
    CountryList() {
      this.$api
        .getAPI({
          _action: "/country/list",
        })
        .then((res) => {
          this.countryList = res;
        })
        .catch(() => {});
    },

    companylist(type) {
      if (!type || type == "TRUE") {
        this.$refs.errorComponent.updateFormLoader(true);
      }
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids.length > 0) {
        obj.company_ids = this.company_ids;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          this.companyList = res;
            if (!this.isPrefillCall) { // when run this for team page then not clear company_ids - each executive will have same company of this will works
              this.company_ids = [];
            }
            this.isPrefillCall= false;
          if (type) {
            this.loader = false;
            if (this.$refs.errorComponent) {
              // this.$refs.errorComponent.setData(res);
              this.$refs.errorComponent.updateFormLoader(false);
            }
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            // this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    reasonList() {
      this.$api
        .getAPI({
          _action: "/departure/reason/list",
        })
        .then((res) => {
          this.departureReasonList = res;
        })
        .catch(() => {});
    },
    seniorityList(keyword) {
      var obj = {};
      if (keyword) {
        obj.keyword = keyword;
      }
      this.$api
        .getAPI({
          _action: "/seniority/list",
          _body: obj,
        })
        .then((res) => {
          this.senioritylevelList = res;
        })
        .catch(() => {});
    },
    jobFunctionlist(keyword) {
      var obj = {};
      if (keyword) {
        obj.keyword = keyword;
      }
      this.$api
        .getAPI({
          _action: "/job/function/list",
          _body: obj,
        })
        .then((res) => {
          this.jobFunctionList = res;
        })
        .catch(() => {});
    },
    save() {
      // if (!this.$refs.ImagePicker.file && !this.detail.executive_logo) {
      //   this.$notify({
      //     type: "error",
      //     text: "Please upload executive logo",
      //   });
      //   return;
      // }
      if (this.detail.social_media.length > 0) {
        this.detail.linkedin_url = "";
        this.detail.facebook_url = "";
        this.detail.twitter_url = "";
        for (var a in this.detail.social_media) {
          if (this.detail.social_media[a].platform_type == "LinkedIn") {
            this.detail.linkedin_url = this.detail.social_media[a].url;
          }
          if (this.detail.social_media[a].platform_type == "Facebook") {
            this.detail.facebook_url = this.detail.social_media[a].url;
          }
          if (this.detail.social_media[a].platform_type == "Twitter") {
            this.detail.twitter_url = this.detail.social_media[a].url;
          }
        }
      }
      if (
        this.detail.interting_links &&
        this.detail.interting_links.length > 0 &&
        this.detail.interting_links[0].published_date == null &&
        this.detail.interting_links[0].publication_id == "" &&
        this.detail.interting_links[0].headline == "" &&
        this.detail.interting_links[0].url == ""
      ) {
        this.detail.interting_links = [];
      }
      if (
        this.detail.conferences_event &&
        this.detail.conferences_event.length > 0 &&
        this.detail.conferences_event[0].published_date == null &&
        this.detail.conferences_event[0].publication_id == "" &&
        this.detail.conferences_event[0].headline == "" &&
        this.detail.conferences_event[0].url == ""
      ) {
        this.detail.conferences_event = [];
      }
      if (
        this.detail.videos &&
        this.detail.videos.length > 0 &&
        this.detail.videos[0].title == "" &&
        this.detail.videos[0].video_url == ""
      ) {
        this.detail.videos = [];
      }
      this.detail.executive_company = this.executive_company;
      if (this.id) {
        this.detail.id = this.id;
        this.$api
          .putAPI({
            _action: "/executive",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            if (!this.$refs.ImagePicker.file) {
              this.$router.go(-1);
            } else {
              this.uploadImage(res.id);
            }
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/executive",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            if (!this.$refs.ImagePicker.file) {
              this.$router.go(-1);
            } else {
              this.uploadImage(res.id);
            }
          })
          .catch(() => {});
      }
    },
    uploadImage(id) {
      if (this.isTeamExecutivePopup) {
        this.updateArrOfTeamExecuitvePopup();
      }      
      this.$api
        .uploadImageAPI({
          _action: "/executive/logo",
          _key: "image",
          _file: this.$refs.ImagePicker.file,
          _body: {
            id: id,
          },
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          // this.$router.go(-1);
          var changeTab = 6;
          this.getDetail(changeTab);          
          // this.changeTabAndScrollTop(6);
        })
        .catch(() => {
          // ❗ error already notified in WebService
          // so nothing required here unless you want UI state changes
        });
    },
    uploadImageFromExternalUrl(id) {
      if (!id || !this.detail.executive_logo) return;

      const obj = {
        id: id,
        url: this.detail.executive_logo,
        type: 'EXECUTIVE'
      };

      this.$api.postAPI({
        _action: "/upload/image-external-url",
        _body: obj,
      })
      .then((res) => {
        this.$notify({
          type: "success",
          text: res.message,
        });

        this.changeTabAndScrollTop(6);
      })
      .catch(() => {
        this.$notify({
          type: "error",
          text: "Failed to upload executive logo.",
        });
      });
    },
    changeTab(num) {
      if (!this.detail.id && num !== 1) return; // ✨ simple and clean
      this.activeTab = num;
    },
    changeTabAndScrollTop(num) {
      this.changeTab(num);
      window.scrollTo(0, 0);
    },
    saveExecutiveDetails() {      
      if (this.id) {
        this.detail.id = this.id;
      } else {
        this.detail.id = 0;
      }
      this.$api
        .postAPI({
          _action: "/executive/save-details",
          _body: this.detail,
          _buttonId: "save-button-executive-details",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.id = res.id;
          this.detail.id = res.id;

          if (this.isTeamExecutivePopup) {
            this.updateArrOfTeamExecuitvePopup();
          }
          
          // if (this.$refs.ImagePicker.file) {
          //   this.uploadImage(res.id);
          // }
          var changeTab = 2;
          this.getDetail(changeTab);
        })
        .catch(() => {});
    },
    saveExecutiveCareerHistory() {
      this.detail.id = this.id;
      if (!this.detail.id) {
        this.$notify({
          type: "error",
          text: "Please refresh the page and try again.",
        });
        return;
      }
      this.$api
        .postAPI({
          _action: "/executive/save-career-history",
          _body: this.detail,
          _buttonId: "save-button-executive-career-history",
        })
        .then((res) => {
          if (this.isTeamExecutivePopup) {
            this.updateArrOfTeamExecuitvePopup();
          }          
          this.$notify({
            type: "success",
            text: res.message,
          });
          var changeTab = 3;
          this.getDetail(changeTab);
        })
        .catch(() => {});
    },
    saveExecutivxeBioSourceResponsibility() {
      this.detail.id = this.id;
      if (!this.detail.id) {
        this.$notify({
          type: "error",
          text: "Please refresh the page and try again.",
        });
        return;
      }
      this.$api
        .postAPI({
          _action: "/executive/save-bio-responsibility",
          _body: this.detail,
          _buttonId: "save-button-executive-biography-responsibility",
        })
        .then((res) => {
          if (this.isTeamExecutivePopup) {
            this.updateArrOfTeamExecuitvePopup();
          }          
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.changeTabAndScrollTop(4);
          // only seeds the fallback row when no fact exists yet; never wipes saved facts
          this.prefillFacts();
        })
        .catch(() => {});
    },
    saveExecutiveContactWebReferences() {
      if (this.detail.social_media.length > 0) {
        this.detail.linkedin_url = "";
        this.detail.facebook_url = "";
        this.detail.twitter_url = "";
        for (var a in this.detail.social_media) {
          if (this.detail.social_media[a].platform_type == "LinkedIn") {
            this.detail.linkedin_url = this.detail.social_media[a].url;
          }
          if (this.detail.social_media[a].platform_type == "Facebook") {
            this.detail.facebook_url = this.detail.social_media[a].url;
          }
          if (this.detail.social_media[a].platform_type == "Twitter") {
            this.detail.twitter_url = this.detail.social_media[a].url;
          }
          if (this.detail.social_media[a].platform_type == "Glassdoor") {
            this.detail.glassdoor_url = this.detail.social_media[a].url;
          }
        }
      }
      if (
        this.detail.interting_links &&
        this.detail.interting_links.length > 0 &&
        this.detail.interting_links[0].published_date == null &&
        this.detail.interting_links[0].publication_id == "" &&
        this.detail.interting_links[0].headline == "" &&
        this.detail.interting_links[0].url == ""
      ) {
        this.detail.interting_links = [];
      }
      if (
        this.detail.conferences_event &&
        this.detail.conferences_event.length > 0 &&
        this.detail.conferences_event[0].published_date == null &&
        this.detail.conferences_event[0].publication_id == "" &&
        this.detail.conferences_event[0].headline == "" &&
        this.detail.conferences_event[0].url == ""
      ) {
        this.detail.conferences_event = [];
      }
      if (
        this.detail.videos &&
        this.detail.videos.length > 0 &&
        this.detail.videos[0].title == "" &&
        this.detail.videos[0].video_url == ""
      ) {
        this.detail.videos = [];
      }
      this.detail.id = this.id;
      if (!this.detail.id) {
        this.$notify({
          type: "error",
          text: "Please refresh the page and try again.",
        });
        return;
      }
      this.$api
        .postAPI({
          _action: "/executive/save-web-contact",
          _body: this.detail,
          _buttonId: "save-button-executive-contact-web-references",
        })
        .then((res) => {
          if (this.isTeamExecutivePopup) {
            this.updateArrOfTeamExecuitvePopup();
          }          
          this.$notify({
            type: "success",
            text: res.message,
          });
          // this.changeTabAndScrollTop(5);
          var changeTab = 5;
          this.getDetail(changeTab);          
          // this.$router.go(-1);
        })
        .catch(() => {});
    },
    // saveExecutiveLogo() {
    //   this.detail.id = this.id;
    //   if (!this.detail.id) {
    //     this.$notify({
    //       type: "error",
    //       text: "Please refresh the page and try again.",
    //     });
    //     return;
    //   }
    //   if (this.$refs.ImagePicker.file) {
    //     this.uploadImage(this.detail.id);
    //   } else {
    //     this.$notify({
    //       type: "error",
    //       text: "Please select an image to upload.",
    //     });
    //   }
    // },
    saveExecutiveLogo() {
      if (!this.detail.id) this.detail.id = this.id;

      if (!this.detail.id) {
        this.$notify({
          type: "error",
          text: "Please refresh the page and try again.",
        });
        return;
      }

      const picker = this.$refs.ImagePicker;

      // CASE 1: NEW FILE UPLOADED
      if (picker.file) {
        this.uploadImage(this.detail.id);
        return;
      }

      var s3baseurl = (this.detail.s3_base_url || '').replace(/\/+$/, '') // remove trailing slash(s) (amazonaws.com)
      // CASE 2 – External URL (AI logo or edited URL)
      if (this.detail.executive_logo && !this.detail.executive_logo.includes(s3baseurl)) {
        this.uploadImageFromExternalUrl(this.detail.id);
        return;
      }

      // CASE 3 – Already S3 image (edit mode)
      if (this.detail.executive_logo) {
        // this.$router.go(-1);
        this.changeTabAndScrollTop(6);
        return;
      }

      // CASE 4: NO FILE + NO EXISTING IMAGE
      this.$notify({
        type: "error",
        text: "Please select an image to upload.",
      });
    },
    updateArrOfTeamExecuitvePopup() {
      if (this.isTeamExecutivePopup) {
        this.$emit("created", {            // this code is update the teamExecutiveList item's id - (triggered @created="onExecutiveCreated" of TeamExecutiveModel)
          // id: res.id,
          detail: { ...this.detail }, 
        });
      }
    },
    prefillFacts(res) {
      const apiFacts = res?.facts || [];

      // EDIT CASE: facts already exist from DB
      if (apiFacts.length > 0) {
        this.detail.facts = apiFacts.map((f) => ({
          text: f.fact ?? "",
        }));
      } else {
        // no facts in the API response. keep whatever the form already holds,
        // otherwise saving another tab (skills/bio) would wipe the facts that
        // were loaded from DB earlier.
        const existing = (this.detail.facts || []).filter(
          (f) => f && typeof f.text === "string" && f.text.trim()
        );

        if (existing.length > 0) {
          this.detail.facts = existing;
        } else {
          // ADD CASE: nothing anywhere → fallback to responsibility
          const fallback = res?.current_responsibility ?? this.detail.current_responsibility ?? "";
          this.detail.facts = [{ text: fallback }];
        }
      }

      // safety: ensure at least one row
      if (!this.detail.facts.length) {
        this.detail.facts = [{ text: "" }];
      }
    },
    addFact() {
      if (this.detail.facts.length >= 5) return;
      this.detail.facts.push({ text: "" });
    },

    removeFact(index) {
      if (this.detail.facts.length === 1) return;
      this.detail.facts.splice(index, 1);
    },
    saveExecutiveFacts() {
      this.detail.id = this.id;
      if (!this.detail.id) {
        this.$notify({
          type: "error",
          text: "Please refresh the page and try again.",
        });
        return;
      }
      this.$api
        .postAPI({
          _action: "/executive/save-fects",
          _body: this.detail,
          _buttonId: "save-button-executive-facts",
        })
        .then((res) => {
          if (this.isTeamExecutivePopup) {
            this.updateArrOfTeamExecuitvePopup();
          }          
          this.$notify({
            type: "success",
            text: res.message,
          });
          // this.changeTabAndScrollTop(6);
          if (!this.isTeamExecutivePopup) {
            this.$router.go(-1);
          }
        })
        .catch(() => {});
    },
    showPublicationPopup() {
      this.$refs.textModal.showModal();
      this.$refs.changePasswordForm.resetForm();
    },
    addPubliction() {
      this.detail.package_group_type = "web";
      this.$api
        .postAPI({
          _action: "/publications",
          _body: this.detail,
          _buttonId: "publication-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          if (!this.$refs.publication_logo.file) {
            this.publicationlist();
            this.detail.publication_id = res.id;
            this.$refs.textModal.closeModal();
          } else {
            this.uploadPublicationImage(res.id);
          }
        })
        .catch(() => {});
    },
    uploadPublicationImage(id) {
      this.$api
        .uploadImageAPI({
          _action: "/publications/logo",
          _key: "image",
          _file: this.$refs.publication_logo.file,
          _body: {
            id: id,
          },
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.publicationlist();
          this.detail.publication_id = res.id;
          this.$refs.textModal.closeModal();
        });
    },
    onChange(e) {
      let files = e.target.files;

      let reader = new FileReader();

      reader.readAsDataURL(files[0]);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          var width = img.width;
          var height = img.height;
          if (width > 500 || height > 500) {
            alert("Image should be of 500 x 500 Pixcel");
            return;
          } else {
            if (files[0].type.toLowerCase() != "image/jpeg" && files[0].type.toLowerCase() != "image/png") {
              alert("Invalid file formate, please use jpeg or png file.");
              return;
            }
            // const size = (files[0].size / 1024 / 1024).toFixed(2);
            // if (size > 10) {
            //   alert("File must be less then 10 MB");
            //   return;
            // }
            var tmppath = URL.createObjectURL(files[0]);
            this.file = files[0];
            document.getElementById("preview").src = tmppath;
          }
        };

        img.src = evt.target.result;
      };
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: white !important;
  height: auto !important;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}

.option-icon {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
}

.option-icon2 {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-left: 20px;
}

.biography-buttn {
  /* --- GREEN GRADIENT --- */
  background: linear-gradient(to right, #4caf50 0%, #45a049 50%, #4caf50 100%) !important;
  color: #fff !important;

  /* --- SHADOW + BORDER --- */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.14);
  border: 1px solid transparent;
  border-radius: 5px;

  /* --- SMALL BUTTON SIZE --- */
  font-size: 12px !important;
  font-weight: 400;
  line-height: 1 !important;
  height: 28px !important;
  padding: 2px 10px !important;

  /* --- EXTRA --- */
  cursor: pointer;
  display: inline-block;
}

.tabs {
  display: flex;
  gap: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}
.tabs li {
  list-style: none;
  padding: 10px 15px;
  cursor: pointer;
}
.tabs li.active {
  background: #1976d2;
  color: #fff;
  border-radius: 4px 4px 0 0;
}
.tabs li.disabled {
  opacity: 0.4;
  pointer-events: none;
}
label {
  margin-bottom: 0;
}
.ainotfoundmessage {
  margin-top: 12px;
  padding: 10px 12px;
  background: #fff8e1;
  border: 1px solid #ffe0b2;
  border-radius: 4px;
  font-size: 13px;
  color: #6b4f00;
}

.ainotfoundmessage ul {
  margin: 0;
  padding-left: 18px;
}

.ainotfoundmessage li {
  margin-bottom: 4px;
}
.ai-info-wrapper {
  position: relative;
}

.ai-info-popup {
  position: absolute;
  top: 34px;
  left: 0;
  right: auto;

  min-width: 420px;
  max-width: 520px;
  max-height: 260px;
  overflow-y: auto;

  background: #fff;
  border: 1px solid #ddd;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.4;
  z-index: 9999;
}

.ai-popup-header {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.ai-popup-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: contain;
  background: #f5f5f5;
}
.ai-info-btn {
  cursor: pointer;
  font-size: 20px;
}
.ai-info-row {
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.ai-info-row:last-child {
  border-bottom: none;
}
.ai-info-row {
  display: flex;
  gap: 6px;
}

.ai-info-row strong {
  min-width: 100px;
  font-weight: 600;
  color: #000;
}
</style>
